export type SupportedLanguage = 'en' | 'es' | 'it';

export const supportedLanguages: SupportedLanguage[] = ['en', 'es', 'it'];

export const languageLabels: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
  it: 'Italiano',
};

export const translations = {
  en: {
    'common.loading': 'Loading...',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.search': 'Search',
    Payment: 'Payment',
    'sidebar.dashboard': 'Home',
    'sidebar.commandCenter': 'Command Center',
    'sidebar.patients': 'Patients',
    'term.patient': 'Patient',
    'term.patients': 'Patients',
    'term.client': 'Client',
    'term.clients': 'Clients',
    'sidebar.messages': 'Messages',
    'sidebar.today': 'Today',
    'sidebar.appointments': 'Appointments',
    'sidebar.walkInUrgentCare': 'Walk-In Triage',
    'sidebar.telemedicine': 'Telemedicine',
    'sidebar.prescriptions': 'Prescriptions',
    'sidebar.billing': 'Billing',
    'sidebar.offersPackages': 'Offers & Packages',
    'sidebar.promotions': 'Promotions',
    'sidebar.packages': 'Packages',
    'sidebar.loyalty': 'Loyalty',
    'sidebar.pos': 'POS',
    'sidebar.staffOperations': 'Staff Operations',
    'sidebar.timesheets': 'Timesheets',
    'sidebar.mobileCapture': 'Mobile Capture',
    'sidebar.leads': 'Leads',
    'sidebar.inventory': 'Inventory',
    'sidebar.advancedInventory': 'Advanced Inventory',
    'sidebar.marketing': 'Marketing',
    'sidebar.reports': 'Reports',
    'sidebar.audit': 'Audit',
    'sidebar.labReports': 'Lab Reports',
    'sidebar.radiology': 'Radiology',
    'sidebar.fse': 'FSE',
    'sidebar.populationHealth': 'Population Health',
    'populationHealth.title': 'Patients Health Intelligence',
    'sidebar.settings': 'Settings',
    'topbar.searchPlaceholder': 'Search patients, appointments, notes...',
    'topbar.notifications': 'Notifications',
    'topbar.noNotifications': 'No notifications yet.',
    'topbar.mock': 'Mock',
    'topbar.markAllRead': 'Mark all as read',
    'topbar.clearAll': 'Clear all',
    'topbar.profileSettings': 'Profile Settings',
    'topbar.signOut': 'Sign out',
    'settings.title': 'Configuration',
    'settings.section': 'Settings',
    'settings.profile': 'Organization Profile',
    'settings.locations': 'Locations',
    'settings.users': 'Team',
    'settings.roles': 'Roles & Permissions',
    'settings.providers': 'Providers',
    'settings.appointmentTypes': 'Appointment Types',
    'settings.resources': 'Resources (Staff)',
    'settings.practiceUsers': 'Practice Users',
    'settings.scheduleAssets': 'Schedule Assets',
    'settings.scheduling': 'Scheduling',
    'settings.telemed': 'Telemedicine',
    'settings.billingCatalog': 'Billables Catalog',
    'settings.medicalForms': 'Medical Forms',
    'settings.treatmentPlans': 'Treatment Plans',
    'settings.myAccount': 'My Account',
    'account.title': 'My Account',
    'account.subtitle': 'Manage personal profile, language, and user preferences.',
    'account.personal': 'Personal Information',
    'account.preferences': 'Locale & App Preferences',
    'account.notifications': 'Notifications',
    'account.signature': 'Clinical Signature',
    'account.language': 'Preferred Language',
    'account.orgLanguage': 'Organization Default Language',
    'account.effectiveLanguage': 'Effective App Language',
    'account.saved': 'Profile updated successfully.',
    'account.defaultLanding': 'Default Landing Page',
    'account.timezone': 'Time Zone',
    'account.dateFormat': 'Date Format',
    'account.timeFormat': 'Time Format',
    'account.firstName': 'First Name',
    'account.lastName': 'Last Name',
    'account.titleField': 'Professional Title',
    'account.phone': 'Phone',
    'account.email': 'Email',
    'profile.orgDefaultLanguage': 'Organization Default Language',
    'profile.enabledLanguages': 'Enabled Languages',
    'profile.domainLanguageDefaults': 'Domain Language Defaults',
    'Live AI Suggestion On': 'Live AI Suggestion On',
    'Live AI Suggestion Off': 'Live AI Suggestion Off',
    'Additional Questions': 'Additional Questions',
    'Next Documentation Line': 'Next Documentation Line',
    'Prescription draft saved successfully.': 'Prescription draft saved successfully.',
    'Prescription sent successfully.': 'Prescription sent successfully.',
  },
  es: {
    'common.loading': 'Cargando...',
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.close': 'Cerrar',
    'common.search': 'Buscar',
    Payment: 'Pago',
    'sidebar.dashboard': 'Inicio',
    'sidebar.commandCenter': 'Centro de mando',
    'sidebar.patients': 'Pacientes',
    'term.patient': 'Paciente',
    'term.patients': 'Pacientes',
    'term.client': 'Cliente',
    'term.clients': 'Clientes',
    'sidebar.messages': 'Mensajes',
    'sidebar.today': 'Hoy',
    'sidebar.appointments': 'Citas',
    'sidebar.walkInUrgentCare': 'Triaje de Urgencias',
    'sidebar.telemedicine': 'Telemedicina',
    'sidebar.prescriptions': 'Recetas',
    'sidebar.billing': 'Facturación',
    'sidebar.inventory': 'Inventario',
    'sidebar.leads': 'Leads',
    'sidebar.timesheets': 'Hojas de tiempo',
    'sidebar.offersPackages': 'Ofertas y paquetes',
    'sidebar.reports': 'Reportes',
    'sidebar.labReports': 'Reportes de Laboratorio',
    'sidebar.radiology': 'Radiologia',
    'sidebar.fse': 'FSE',
    'sidebar.populationHealth': 'Salud Poblacional',
    'sidebar.settings': 'Configuración',
    'topbar.searchPlaceholder': 'Buscar pacientes, citas y notas...',
    'topbar.notifications': 'Notificaciones',
    'topbar.noNotifications': 'Aún no hay notificaciones.',
    'topbar.mock': 'Simular',
    'topbar.markAllRead': 'Marcar todo como leído',
    'topbar.clearAll': 'Borrar todo',
    'topbar.profileSettings': 'Configuración de perfil',
    'topbar.signOut': 'Cerrar sesión',
    'settings.title': 'Configuración',
    'settings.section': 'Ajustes',
    'settings.profile': 'Perfil de la organización',
    'settings.locations': 'Sedes',
    'settings.users': 'Equipo',
    'settings.roles': 'Roles y permisos',
    'settings.providers': 'Profesionales',
    'settings.appointmentTypes': 'Tipos de cita',
    'settings.resources': 'Recursos (Personal)',
    'settings.practiceUsers': 'Usuarios de la consulta',
    'settings.scheduleAssets': 'Activos programables',
    'settings.scheduling': 'Agenda',
    'settings.telemed': 'Telemedicina',
    'settings.billingCatalog': 'Catálogo facturable',
    'settings.medicalForms': 'Formularios médicos',
    'settings.treatmentPlans': 'Planes de tratamiento',
    'settings.myAccount': 'Mi cuenta',
    'account.title': 'Mi cuenta',
    'account.subtitle': 'Gestiona tu perfil personal, idioma y preferencias de usuario.',
    'account.personal': 'Información personal',
    'account.preferences': 'Preferencias de idioma y aplicación',
    'account.notifications': 'Notificaciones',
    'account.signature': 'Firma clínica',
    'account.language': 'Idioma preferido',
    'account.orgLanguage': 'Idioma por defecto de la organización',
    'account.effectiveLanguage': 'Idioma efectivo de la app',
    'account.saved': 'Perfil actualizado correctamente.',
    'account.passwordRequired': 'Debes cambiar la contraseña antes de continuar.',
    'account.passwordUpdated': 'Contraseña actualizada correctamente.',
    'account.passwordUpdateFailed': 'No se pudo actualizar la contraseña.',
    'account.passwordMismatch': 'La nueva contraseña y la confirmación no coinciden.',
    'account.defaultLanding': 'Pantalla inicial por defecto',
    'account.timezone': 'Zona horaria',
    'account.dateFormat': 'Formato de fecha',
    'account.timeFormat': 'Formato de hora',
    'account.firstName': 'Nombre',
    'account.lastName': 'Apellido',
    'account.titleField': 'Título profesional',
    'account.phone': 'Teléfono',
    'account.email': 'Correo electrónico',
    'profile.orgDefaultLanguage': 'Idioma predeterminado de la organización',
    'profile.enabledLanguages': 'Idiomas habilitados',
    'profile.domainLanguageDefaults': 'Idioma por dominio',
    'Organization Profile': 'Perfil de la organización',
    "Manage your health group's identity and details.": 'Gestiona la identidad y los datos de tu grupo sanitario.',
    'Seeding...': 'Cargando datos...',
    'Seed Demo Data': 'Generar datos de demostración',
    'Saving...': 'Guardando...',
    'Save Changes': 'Guardar cambios',
    'Identity & Branding': 'Identidad y marca',
    'Basic organization details.': 'Datos básicos de la organización.',
    'Tenant Name (Display Name)': 'Nombre del tenant (nombre visible)',
    'Legal Name': 'Nombre legal',
    'Slogan / Tagline': 'Lema / eslogan',
    'Logo URL': 'URL del logo',
    'Uploading...': 'Subiendo...',
    'Upload Logo': 'Subir logo',
    'Remove': 'Eliminar',
    'Organization logo': 'Logo de la organización',
    'Contact & Regional': 'Contacto y región',
    'Address and localization.': 'Dirección y configuración regional.',
    'Official Website': 'Sitio web oficial',
    'Primary Phone': 'Teléfono principal',
    'General Email': 'Correo general',
    'Headquarters Address': 'Dirección principal',
    'Time Zone': 'Zona horaria',
    'Currency': 'Moneda',
    'Enabled Languages': 'Idiomas habilitados',
    'Domain Language Defaults': 'Valores predeterminados por dominio',
    'Compliance & Clinical': 'Cumplimiento y clínica',
    'Regulatory and leadership info.': 'Información normativa y de dirección.',
    'Tenant / display name is required': 'El nombre del tenant / visible es obligatorio',
    'Legal name is required': 'El nombre legal es obligatorio',
    'Primary phone is required': 'El teléfono principal es obligatorio',
    'General email is required': 'El correo general es obligatorio',
    'Enter a valid email address': 'Ingresa una dirección de correo válida',
    'Headquarters address is required': 'La dirección principal es obligatoria',
    'Time zone is required': 'La zona horaria es obligatoria',
    'Default language is required': 'El idioma predeterminado es obligatorio',
    'Domain language defaults must be valid JSON.': 'Los valores predeterminados por dominio deben ser JSON válido.',
    'Website must include http(s)://': 'El sitio web debe incluir http(s)://',
    'Tax ID / EIN': 'ID fiscal / EIN',
    'NPI / Registration Number': 'NPI / número de registro',
    'Accreditation (e.g. JCI, ISO)': 'Acreditación (p. ej. JCI, ISO)',
    'Medical Director': 'Director médico',
    'Privacy Officer': 'Responsable de privacidad',
    'Specialties': 'Especialidades',
    'Saved successfully': 'Guardado correctamente',
    'Reset and seed demo data for this organization? This clears existing tenant data (except users and organization) and recreates demo records.':
      '¿Restablecer y generar datos de demostración para esta organización? Esto borra los datos existentes del tenant (excepto usuarios y organización) y recrea los registros de demostración.',
    'Seed complete: {providers} providers, {patients} patients, {appointments} appointments, {invoices} invoices, {prescriptions} prescriptions, {alerts} alerts, {cases} population-health cases.':
      'Generación completa: {providers} profesionales, {patients} pacientes, {appointments} citas, {invoices} facturas, {prescriptions} recetas, {alerts} alertas, {cases} casos de salud poblacional.',
    'Failed to seed demo data.': 'No se pudieron generar los datos de demostración.',
    'Logo must be a PNG or JPEG image.': 'El logo debe ser una imagen PNG o JPEG.',
    'Logo file must be 5MB or smaller.': 'El archivo del logo debe ser de 5MB o menos.',
    'Logo upload failed.': 'La carga del logo falló.',
    Error: 'Error',
    'e.g. NeoHealth Group': 'p. ej. NeoHealth Group',
    'e.g. NeoHealth Services, Inc.': 'p. ej. NeoHealth Services, Inc.',
    'e.g. Care for the Future': 'p. ej. Care for the Future',
    'Location saved': 'Ubicación guardada',
    'Location name is required': 'El nombre de la ubicación es obligatorio',
    'Address line 1 is required': 'La dirección línea 1 es obligatoria',
    'City is required': 'La ciudad es obligatoria',
    'State / Province is required': 'El estado / provincia es obligatorio',
    'Postal code is required': 'El código postal es obligatorio',
    'Country is required': 'El país es obligatorio',
    'Timezone is required': 'La zona horaria es obligatoria',
    'Contact phone is required': 'El teléfono de contacto es obligatorio',
    'Enter a valid email': 'Ingresa un correo válido',
    'needs start and end times': 'necesita hora de inicio y fin',
    'end time must be after start': 'la hora de fin debe ser posterior a la de inicio',
    'Failed to load locations': 'No se pudieron cargar las ubicaciones',
    'Unable to save location': 'No se pudo guardar la ubicación',
    'Unable to delete location': 'No se pudo eliminar la ubicación',
    'Delete this location?': '¿Eliminar esta ubicación?',
    'Untitled': 'Sin título',
    'Loading...': 'Cargando...',
    'Primary Care, Labs, Imaging': 'Atención primaria, laboratorios, imágenes',
    'For claims and referrals': 'Para reclamaciones y derivaciones',
    'EIN for the site': 'EIN para la sede',
    'Monday': 'Lunes',
    'Tuesday': 'Martes',
    'Wednesday': 'Miércoles',
    'Thursday': 'Jueves',
    'Friday': 'Viernes',
    'Saturday': 'Sábado',
    'Sunday': 'Domingo',
    'Locations': 'Ubicaciones',
    'Manage clinics, offices, and operating hours.': 'Administra clínicas, oficinas y horarios de atención.',
    'Add Location': 'Agregar ubicación',
    'Search locations...': 'Buscar ubicaciones...',
    'No locations found.': 'No se encontraron ubicaciones.',
    'Name': 'Nombre',
    'Address': 'Dirección',
    'Timezone': 'Zona horaria',
    'Status': 'Estado',
    'Actions': 'Acciones',
    'Primary': 'Principal',
    'Telemed': 'Telemedicina',
    'Edit location': 'Editar ubicación',
    'Delete location': 'Eliminar ubicación',
    'Location': 'Ubicación',
    'Close': 'Cerrar',
    'Location Name': 'Nombre de la ubicación',
    'Facility Type': 'Tipo de centro',
    'Clinic, Office, Lab': 'Clínica, oficina, laboratorio',
    'Address Line 1': 'Dirección línea 1',
    'Address Line 2': 'Dirección línea 2',
    'City': 'Ciudad',
    'State / Province': 'Estado / provincia',
    'Postal Code': 'Código postal',
    'Country': 'País',
    'Contact Phone': 'Teléfono de contacto',
    'Contact Email': 'Correo de contacto',
    'Front Desk Contact': 'Contacto de recepción',
    'Services Offered': 'Servicios ofrecidos',
    'Billing NPI': 'NPI de facturación',
    'Billing Tax ID': 'ID fiscal de facturación',
    'Patient Directions': 'Indicaciones para pacientes',
    'Access & Parking': 'Acceso y estacionamiento',
    'Telemed / Special Instructions': 'Telemedicina / instrucciones especiales',
    'Internal Notes': 'Notas internas',
    'Telemedicine Available': 'Telemedicina disponible',
    'Primary Location': 'Ubicación principal',
    'Sets this as the default site for scheduling': 'Establece este sitio como predeterminado para programación',
    'Opening Hours': 'Horario de atención',
    '24/7': '24/7',
    'Open': 'Abierto',
    'Closed': 'Cerrado',
    'Save': 'Guardar',
    'Provider Management': 'Gestión de proveedores',
    'Provider Directory': 'Directorio de profesionales',
    'Open a provider profile to manage credentials, linked user access, and self-scheduling windows in one place.':
      'Abre un perfil de profesional para gestionar credenciales, acceso del usuario vinculado y ventanas de autoscheduling en un solo lugar.',
    'Add Provider': 'Agregar profesional',
    'Search providers...': 'Buscar profesionales...',
    'No providers found.': 'No se encontraron profesionales.',
    'Failed to load provider details.': 'No se pudieron cargar los detalles del profesional.',
    'Manage provider details, linked access, signatures, and patient self-scheduling from one page.':
      'Gestiona los detalles del profesional, el acceso vinculado, las firmas y la auto-programación de pacientes desde una sola página.',
    'Save Provider': 'Guardar profesional',
    'New Provider': 'Nuevo profesional',
    'No linked user': 'Sin usuario vinculado',
    'No linked user yet': 'Todavía no hay usuario vinculado',
    'Open provider profile': 'Abrir perfil del profesional',
    'Active': 'Activo',
    'Inactive': 'Inactivo',
    'Scheduling ready': 'Listo para programación',
    'Link user for scheduling': 'Vincular usuario para programación',
    'Scheduling enabled': 'Programación habilitada',
    'Telemed enabled': 'Telemedicina habilitada',
    'Telemed off': 'Telemedicina desactivada',
    'Linked user': 'Usuario vinculado',
    'None': 'Ninguno',
    'Delete': 'Eliminar',
    'Delete this provider?': '¿Eliminar este profesional?',
    'Provider deleted': 'Profesional eliminado',
    'Provider saved': 'Profesional guardado',
    'Unable to delete provider': 'No se pudo eliminar el profesional',
    'Unable to delete provider.': 'No se pudo eliminar el profesional.',
    'Unable to save provider.': 'No se pudo guardar el profesional.',
    'Provider Details': 'Detalles del profesional',
    'Use this record as the single source of truth for provider identity, credentials, and linked access.':
      'Usa este registro como la fuente de verdad para la identidad, credenciales y acceso vinculado del profesional.',
    'Linked User (optional)': 'Usuario vinculado (opcional)',
    Type: 'Tipo',
    'License #': 'N. de licencia',
    NPI: 'NPI',
    'Active Provider': 'Profesional activo',
    'Specialties (comma separated)': 'Especialidades (separadas por coma)',
    'Languages (comma separated)': 'Idiomas (separados por coma)',
    'Location IDs (comma separated)': 'IDs de ubicación (separados por coma)',
    'Profile Avatar URL': 'URL del avatar de perfil',
    'Signature Block / Image URL': 'Bloque de firma / URL de imagen',
    'Media & Signature': 'Medios y firma',
    'Upload or draw the provider assets used across the chart, telemed, and documents.':
      'Sube o dibuja los recursos del profesional usados en la historia clínica, telemedicina y documentos.',
    'Upload Profile Avatar': 'Subir avatar de perfil',
    'Upload Signature Image': 'Subir imagen de firma',
    'Avatar uploaded. Save provider to persist.': 'Avatar subido. Guarda el profesional para persistirlo.',
    'Avatar upload failed.': 'Falló la carga del avatar.',
    'Signature uploaded. Save provider to persist.': 'Firma subida. Guarda el profesional para persistirla.',
    'Signature upload failed.': 'Falló la carga de la firma.',
    'Avatar image must be a PNG, JPEG, or WEBP file.': 'El avatar debe ser un archivo PNG, JPEG o WEBP.',
    'Avatar image must be 5MB or smaller.': 'El avatar debe pesar 5MB o menos.',
    'Signature image must be a PNG or JPEG file.': 'La firma debe ser un archivo PNG o JPEG.',
    'Signature image must be 3MB or smaller.': 'La firma debe pesar 3MB o menos.',
    'Drawn signature applied. Save provider to persist.': 'Firma dibujada aplicada. Guarda el profesional para persistirla.',
    'Draw a signature first.': 'Dibuja una firma primero.',
    'Or draw signature live': 'O dibuja la firma en vivo',
    'Use Drawing': 'Usar dibujo',
    'Failed to load providers': 'No se pudieron cargar los profesionales',
    'Roles & Permissions': 'Roles y permisos',
    'Define access levels and map permissions.': 'Define niveles de acceso y asigna permisos.',
    'Add Role': 'Agregar rol',
    'Search roles...': 'Buscar roles...',
    'Role': 'Rol',
    'Description': 'Descripción',
    'Permissions': 'Permisos',
    'No roles found.': 'No se encontraron roles.',
    'No permissions': 'Sin permisos',
    'more': 'más',
    'Edit role': 'Editar rol',
    'Add role': 'Agregar rol',
    'Role is required': 'El rol es obligatorio',
    'Description is required': 'La descripción es obligatoria',
    'Role saved': 'Rol guardado',
    'Unable to save role': 'No se pudo guardar el rol',
    'Delete is not available for roles.': 'El borrado no está disponible para los roles.',
    'Select a role': 'Selecciona un rol',
    'What this role can do': 'Qué puede hacer este rol',
    'Select the permissions granted to this role.': 'Selecciona los permisos otorgados a este rol.',
    'Failed to load roles': 'No se pudieron cargar los roles',
    'Add New User': 'Agregar usuario',
    'A secure temporary password will be auto-generated and emailed to the user.':
      'Se generará automáticamente una contraseña temporal segura y se enviará por correo al usuario.',
    'Prefill demo data': 'Rellenar datos de demostración',
    'First Name': 'Nombre',
    'Last Name': 'Apellido',
    'Email': 'Correo electrónico',
    'Initial Language': 'Idioma inicial',
    'Use organization default': 'Usar el valor predeterminado de la organización',
    'Additional Roles': 'Roles adicionales',
    'Title (optional)': 'Cargo (opcional)',
    'Phone (optional)': 'Teléfono (opcional)',
    'Create User': 'Crear usuario',
    'Creating...': 'Creando...',
    'Edit User': 'Editar usuario',
    'Title': 'Cargo',
    'Phone': 'Teléfono',
    'Active user': 'Usuario activo',
    'Profile Association': 'Asociación de perfil',
    'Linked As': 'Vinculado como',
    'Not linked': 'No vinculado',
    'Provider': 'Profesional',
    'Staff': 'Personal',
    'Provider Profile': 'Perfil del profesional',
    'Auto-create or use linked provider': 'Crear automáticamente o usar un profesional vinculado',
    'Provider Type (optional override)': 'Tipo de profesional (anulación opcional)',
    Coordination: 'Coordinación',
    'Care Episodes': 'Episodios de atención',
    'Current and past episodes in one workspace table.': 'Episodios actuales y pasados en una sola tabla de trabajo.',
    'No episodes created yet.': 'Aún no se han creado episodios.',
    'New Episode': 'Nuevo episodio',
    'Receptionist': 'Recepcionista',
    'Staff Profile': 'Perfil del personal',
    'Auto-create or use linked staff': 'Crear automáticamente o usar personal vinculado',
    'Staff Role (optional override)': 'Rol del personal (anulación opcional)',
    'Reset Password?': '¿Restablecer contraseña?',
    'Reset password for': 'Restablecer contraseña para',
    'A new temporary password will be emailed.': 'Se enviará por correo una nueva contraseña temporal.',
    'Cancel': 'Cancelar',
    'Confirm Reset': 'Confirmar restablecimiento',
    'Resetting...': 'Restableciendo...',
    'Archive user': 'Archivar usuario',
    'Archived': 'Archivado',
    'Reset Required': 'Restablecimiento requerido',
    'User Management': 'Gestión de usuarios',
    'Manage system access and accounts.': 'Administra el acceso al sistema y las cuentas.',
    'Add User': 'Agregar usuario',
    'Only administrators can access User Management.': 'Solo los administradores pueden acceder a la gestión de usuarios.',
    'Unable to load current user role.': 'No se pudo cargar el rol del usuario actual.',
    'Loading users...': 'Cargando usuarios...',
    'Only administrators can view and manage users.': 'Solo los administradores pueden ver y gestionar usuarios.',
    'Search users...': 'Buscar usuarios...',
    'Linked Profile': 'Perfil vinculado',
    'Reset password': 'Restablecer contraseña',
    'Edit user': 'Editar usuario',
    'User created. Temporary password was sent by email.': 'Usuario creado. La contraseña temporal fue enviada por correo.',
    'User updated successfully.': 'Usuario actualizado correctamente.',
    'Temporary password reset email sent.': 'Se envió el correo de restablecimiento de contraseña temporal.',
    'User archived successfully.': 'Usuario archivado correctamente.',
    'Failed to create user.': 'No se pudo crear el usuario.',
    'Failed to update user.': 'No se pudo actualizar el usuario.',
    'Failed to reset password.': 'No se pudo restablecer la contraseña.',
    'Failed to archive user.': 'No se pudo archivar el usuario.',
    'Failed to load user management.': 'No se pudo cargar la gestión de usuarios.',
    'Unable to load user management.': 'No se pudo cargar la gestión de usuarios.',
    'Unable to load users.': 'No se pudieron cargar los usuarios.',
    'Unable to load roles.': 'No se pudieron cargar los roles.',
    'Unable to load provider profiles.': 'No se pudieron cargar los perfiles de profesionales.',
    'Unable to load staff profiles.': 'No se pudieron cargar los perfiles del personal.',
    'Please select a role.': 'Selecciona un rol.',
    'Select role': 'Selecciona un rol',
    'Doctor': 'Doctor',
    'Archive user {name}? This will also remove their Cognito identity.': '¿Archivar al usuario {name}? Esto también eliminará su identidad de Cognito.',
    'Archive user ': 'Archivar usuario ',
    'This will also remove their Cognito identity.': 'Esto también eliminará su identidad de Cognito.',
    'Failed to update user profile association.': 'No se pudo actualizar la asociación del perfil de usuario.',
    'Roles': 'Roles',
    'Failed to load AI governance workspace.': 'No se pudo cargar el espacio de trabajo de gobernanza de IA.',
    'Failed to refresh AI governance workspace.': 'No se pudo actualizar el espacio de trabajo de gobernanza de IA.',
    'Failed to update AI governance state.': 'No se pudo actualizar el estado de gobernanza de IA.',
  },
  it: {
    'common.loading': 'Caricamento...',
    'common.save': 'Salva',
    'common.cancel': 'Annulla',
    'common.close': 'Chiudi',
    'common.search': 'Cerca',
    Payment: 'Pagamento',
    'sidebar.dashboard': 'Home',
    'sidebar.commandCenter': 'Centro di comando',
    'sidebar.patients': 'Pazienti',
    'term.patient': 'Paziente',
    'term.patients': 'Pazienti',
    'term.client': 'Cliente',
    'term.clients': 'Clienti',
    'sidebar.messages': 'Messaggi',
    'sidebar.today': 'Oggi',
    'sidebar.appointments': 'Appuntamenti',
    'sidebar.walkInUrgentCare': 'Triage Urgenze',
    'sidebar.telemedicine': 'Telemedicina',
    'sidebar.prescriptions': 'Prescrizioni',
    'sidebar.billing': 'Fatturazione',
    'sidebar.inventory': 'Inventario',
    'sidebar.leads': 'Lead',
    'sidebar.timesheets': 'Timesheet',
    'sidebar.reports': 'Reportistica',
    'sidebar.labReports': 'Referti di Laboratorio',
    'sidebar.radiology': 'Radiologia',
    'sidebar.fse': 'FSE',
    'sidebar.populationHealth': 'Salute della Popolazione',
    'populationHealth.title': 'Salute della popolazione',
    'sidebar.settings': 'Impostazioni',
    'topbar.searchPlaceholder': 'Cerca pazienti, appuntamenti e note...',
    'topbar.notifications': 'Notifiche',
    'topbar.noNotifications': 'Nessuna notifica al momento.',
    'topbar.mock': 'Simula',
    'topbar.markAllRead': 'Segna tutto come letto',
    'topbar.clearAll': 'Cancella tutto',
    'topbar.profileSettings': 'Impostazioni profilo',
    'topbar.signOut': 'Disconnetti',
    'settings.title': 'Configurazione',
    'settings.section': 'Impostazioni',
    'settings.profile': 'Profilo organizzazione',
    'settings.locations': 'Sedi',
    'settings.users': 'Team',
    'settings.roles': 'Ruoli e permessi',
    'settings.providers': 'Medici',
    'settings.appointmentTypes': 'Tipi di appuntamento',
    'settings.resources': 'Risorse (Staff)',
    'settings.practiceUsers': 'Utenti dello studio',
    'settings.scheduleAssets': 'Risorse prenotabili',
    'settings.scheduling': 'Pianificazione',
    'settings.telemed': 'Telemedicina',
    'settings.billingCatalog': 'Catalogo fatturabile',
    'settings.medicalForms': 'Moduli medici',
    'settings.treatmentPlans': 'Piani terapeutici',
    'settings.myAccount': 'Il mio account',
    'account.title': 'Il mio account',
    'account.subtitle': 'Gestisci profilo personale, lingua e preferenze utente.',
    'account.personal': 'Informazioni personali',
    'account.preferences': 'Preferenze lingua e applicazione',
    'account.notifications': 'Notifiche',
    'account.signature': 'Firma clinica',
    'account.language': 'Lingua preferita',
    'account.orgLanguage': "Lingua predefinita dell'organizzazione",
    'account.effectiveLanguage': "Lingua effettiva dell'app",
    'account.saved': 'Profilo aggiornato con successo.',
    'account.passwordRequired': 'È necessario cambiare la password prima di continuare.',
    'account.passwordUpdated': 'Password aggiornata correttamente.',
    'account.passwordUpdateFailed': 'Impossibile aggiornare la password.',
    'account.passwordMismatch': 'La nuova password e la conferma non corrispondono.',
    'account.defaultLanding': 'Pagina iniziale predefinita',
    'account.timezone': 'Fuso orario',
    'account.dateFormat': 'Formato data',
    'account.timeFormat': 'Formato ora',
    'account.firstName': 'Nome',
    'account.lastName': 'Cognome',
    'account.titleField': 'Titolo professionale',
    'account.phone': 'Telefono',
    'account.email': 'Email',
    'profile.orgDefaultLanguage': "Lingua predefinita dell'organizzazione",
    'profile.enabledLanguages': 'Lingue abilitate',
    'profile.domainLanguageDefaults': 'Lingua per dominio',
    'Organization Profile': "Profilo dell'organizzazione",
    "Manage your health group's identity and details.": "Gestisci l'identità e i dettagli del tuo gruppo sanitario.",
    'Seeding...': 'Creazione in corso...',
    'Seed Demo Data': 'Genera dati demo',
    'Saving...': 'Salvataggio in corso...',
    'Identity & Branding': 'Identità e brand',
    'Basic organization details.': 'Dettagli di base dell’organizzazione.',
    'Tenant Name (Display Name)': 'Nome tenant (nome visualizzato)',
    'Legal Name': 'Ragione sociale',
    'Slogan / Tagline': 'Slogan / tagline',
    'Logo URL': 'URL logo',
    'Uploading...': 'Caricamento in corso...',
    'Upload Logo': 'Carica logo',
    'Remove': 'Rimuovi',
    'Organization logo': "Logo dell'organizzazione",
    'Contact & Regional': 'Contatti e area geografica',
    'Address and localization.': 'Indirizzo e localizzazione.',
    'Official Website': 'Sito web ufficiale',
    'Primary Phone': 'Telefono principale',
    'General Email': 'Email generale',
    'Headquarters Address': 'Indirizzo sede principale',
    'Time Zone': 'Fuso orario',
    'Currency': 'Valuta',
    'Enabled Languages': 'Lingue abilitate',
    'Domain Language Defaults': 'Lingue predefinite per dominio',
    'Compliance & Clinical': 'Conformità e clinica',
    'Regulatory and leadership info.': 'Informazioni normative e direzionali.',
    'Tenant / display name is required': 'Il nome tenant / visualizzato è obbligatorio',
    'Legal name is required': 'La ragione sociale è obbligatoria',
    'Primary phone is required': 'Il telefono principale è obbligatorio',
    'General email is required': 'L’email generale è obbligatoria',
    'Enter a valid email address': 'Inserisci un indirizzo email valido',
    'Headquarters address is required': "L'indirizzo della sede principale è obbligatorio",
    'Time zone is required': 'Il fuso orario è obbligatorio',
    'Default language is required': 'La lingua predefinita è obbligatoria',
    'Domain language defaults must be valid JSON.': 'Le impostazioni predefinite per dominio devono essere JSON valido.',
    'Website must include http(s)://': 'Il sito web deve includere http(s)://',
    'Tax ID / EIN': 'Codice fiscale / EIN',
    'NPI / Registration Number': 'NPI / numero di registrazione',
    'Accreditation (e.g. JCI, ISO)': 'Accreditamento (es. JCI, ISO)',
    'Medical Director': 'Direttore medico',
    'Privacy Officer': 'Responsabile privacy',
    'Specialties': 'Specialità',
    'needs start and end times': 'richiede ora di inizio e fine',
    'end time must be after start': "l'ora di fine deve essere successiva a quella di inizio",
    'Saved successfully': 'Salvato con successo',
    'Reset and seed demo data for this organization? This clears existing tenant data (except users and organization) and recreates demo records.':
      "Reimpostare e generare dati demo per questa organizzazione? Questo cancella i dati tenant esistenti (tranne utenti e organizzazione) e ricrea i record demo.",
    'Seed complete: {providers} providers, {patients} patients, {appointments} appointments, {invoices} invoices, {prescriptions} prescriptions, {alerts} alerts, {cases} population-health cases.':
      'Generazione completata: {providers} medici, {patients} pazienti, {appointments} appuntamenti, {invoices} fatture, {prescriptions} prescrizioni, {alerts} avvisi, {cases} casi di salute della popolazione.',
    'Failed to seed demo data.': 'Impossibile generare i dati demo.',
    'Logo must be a PNG or JPEG image.': 'Il logo deve essere un’immagine PNG o JPEG.',
    'Logo file must be 5MB or smaller.': 'Il file del logo deve essere di 5 MB o meno.',
    'Logo upload failed.': 'Caricamento logo non riuscito.',
    Error: 'Errore',
    'e.g. NeoHealth Group': 'es. NeoHealth Group',
    'e.g. NeoHealth Services, Inc.': 'es. NeoHealth Services, Inc.',
    'e.g. Care for the Future': 'es. Care for the Future',
    'Failed to load locations': 'Impossibile caricare le sedi',
    'Unable to save location': 'Impossibile salvare la sede',
    'Unable to delete location': 'Impossibile eliminare la sede',
    'Delete this location?': 'Eliminare questa sede?',
    'Untitled': 'Senza titolo',
    'Location saved': 'Sede salvata',
    'Locations': 'Sedi',
    'Manage clinics, offices, and operating hours.': 'Gestisci cliniche, uffici e orari di apertura.',
    'Add Location': 'Aggiungi sede',
    'Search locations...': 'Cerca sedi...',
    'Loading...': 'Caricamento...',
    'Primary Care, Labs, Imaging': 'Assistenza primaria, laboratori, imaging',
    'For claims and referrals': 'Per rimborsi e invii',
    'EIN for the site': 'EIN per la sede',
    'No locations found.': 'Nessuna sede trovata.',
    'Name': 'Nome',
    'Address': 'Indirizzo',
    'Timezone': 'Fuso orario',
    'Status': 'Stato',
    'Actions': 'Azioni',
    'Primary': 'Principale',
    'Telemed': 'Telemedicina',
    'Edit location': 'Modifica sede',
    'Delete location': 'Elimina sede',
    'Location': 'Sede',
    'Add location': 'Aggiungi sede',
    'Close': 'Chiudi',
    'Location Name': 'Nome sede',
    'Facility Type': 'Tipo struttura',
    'Clinic, Office, Lab': 'Clinica, ufficio, laboratorio',
    'Address Line 1': 'Indirizzo riga 1',
    'Address Line 2': 'Indirizzo riga 2',
    'City': 'Città',
    'State / Province': 'Stato / provincia',
    'Postal Code': 'CAP',
    'Country': 'Paese',
    'Contact Phone': 'Telefono di contatto',
    'Contact Email': 'Email di contatto',
    'Front Desk Contact': 'Contatto front desk',
    'Services Offered': 'Servizi offerti',
    'Billing NPI': 'NPI fatturazione',
    'Billing Tax ID': 'Codice fiscale fatturazione',
    'Patient Directions': 'Indicazioni per i pazienti',
    'Access & Parking': 'Accesso e parcheggio',
    'Telemed / Special Instructions': 'Telemedicina / istruzioni speciali',
    'Internal Notes': 'Note interne',
    'Telemedicine Available': 'Telemedicina disponibile',
    'Primary Location': 'Sede principale',
    'Sets this as the default site for scheduling': 'Imposta questa sede come sito predefinito per la pianificazione',
    'Opening Hours': 'Orari di apertura',
    'Weekdays 9-5': 'Giorni feriali 9-17',
    '24/7': '24/7',
    'Mark closed': 'Segna chiuso',
    'Open': 'Aperto',
    'Closed': 'Chiuso',
    'Save': 'Salva',
    'Provider Directory': 'Elenco medici',
    'Open a provider profile to manage credentials, linked user access, and self-scheduling windows in one place.':
      'Apri un profilo medico per gestire credenziali, accesso utente collegato e finestre di auto-prenotazione in un unico posto.',
    'Add Provider': 'Aggiungi medico',
    'Search providers...': 'Cerca medici...',
    'No providers found.': 'Nessun medico trovato.',
    'Failed to load provider details.': 'Impossibile caricare i dettagli del medico.',
    'Manage provider details, linked access, signatures, and patient self-scheduling from one page.':
      'Gestisci i dettagli del medico, l accesso collegato, le firme e l auto-prenotazione pazienti da un’unica pagina.',
    'Save Provider': 'Salva medico',
    'New Provider': 'Nuovo medico',
    'No linked user': 'Nessun utente collegato',
    'No linked user yet': 'Nessun utente collegato ancora',
    'Open provider profile': 'Apri profilo medico',
    'Active': 'Attivo',
    'Inactive': 'Inattivo',
    'Scheduling ready': 'Pronto per la pianificazione',
    'Link user for scheduling': 'Collega utente per la pianificazione',
    'Scheduling enabled': 'Pianificazione abilitata',
    'Telemed enabled': 'Telemedicina abilitata',
    'Telemed off': 'Telemedicina disattivata',
    'Linked user': 'Utente collegato',
    'None': 'Nessuno',
    'Delete': 'Elimina',
    'Delete this provider?': 'Eliminare questo medico?',
    'Provider deleted': 'Medico eliminato',
    'Unable to delete provider': 'Impossibile eliminare il medico',
    'Unable to delete provider.': 'Impossibile eliminare il medico.',
    'Unable to save provider.': 'Impossibile salvare il medico.',
    'Provider Details': 'Dettagli medico',
    'Use this record as the single source of truth for provider identity, credentials, and linked access.':
      'Usa questo record come fonte di verità per identità, credenziali e accesso collegato del medico.',
    'Linked User (optional)': 'Utente collegato (opzionale)',
    Type: 'Tipo',
    'License #': 'N. licenza',
    NPI: 'NPI',
    'Active Provider': 'Medico attivo',
    'Specialties (comma separated)': 'Specialità (separate da virgola)',
    'Languages (comma separated)': 'Lingue (separate da virgola)',
    'Location IDs (comma separated)': 'ID sedi (separati da virgola)',
    'Profile Avatar URL': 'URL avatar profilo',
    'Signature Block / Image URL': 'Blocco firma / URL immagine',
    'Media & Signature': 'Media e firma',
    'Upload or draw the provider assets used across the chart, telemed, and documents.':
      'Carica o disegna le risorse del medico usate in cartella, telemedicina e documenti.',
    'Upload Profile Avatar': 'Carica avatar profilo',
    'Upload Signature Image': 'Carica immagine firma',
    'Avatar uploaded. Save provider to persist.': 'Avatar caricato. Salva il medico per renderlo persistente.',
    'Avatar upload failed.': 'Caricamento avatar non riuscito.',
    'Signature uploaded. Save provider to persist.': 'Firma caricata. Salva il medico per renderla persistente.',
    'Signature upload failed.': 'Caricamento firma non riuscito.',
    'Avatar image must be a PNG, JPEG, or WEBP file.': 'L avatar deve essere un file PNG, JPEG o WEBP.',
    'Avatar image must be 5MB or smaller.': 'L avatar deve essere di 5MB o meno.',
    'Signature image must be a PNG or JPEG file.': 'La firma deve essere un file PNG o JPEG.',
    'Signature image must be 3MB or smaller.': 'La firma deve essere di 3MB o meno.',
    'Drawn signature applied. Save provider to persist.': 'Firma disegnata applicata. Salva il medico per renderla persistente.',
    'Draw a signature first.': 'Disegna prima una firma.',
    'Or draw signature live': 'Oppure disegna la firma dal vivo',
    'Use Drawing': 'Usa disegno',
    'Failed to load providers': 'Impossibile caricare i medici',
    'Roles & Permissions': 'Ruoli e permessi',
    'Define access levels and map permissions.': 'Definisci i livelli di accesso e associa i permessi.',
    'Add Role': 'Aggiungi ruolo',
    'Search roles...': 'Cerca ruoli...',
    'Role': 'Ruolo',
    'Description': 'Descrizione',
    'Permissions': 'Permessi',
    'No roles found.': 'Nessun ruolo trovato.',
    'No permissions': 'Nessun permesso',
    'more': 'altro',
    'Edit role': 'Modifica ruolo',
    'Add role': 'Aggiungi ruolo',
    'Role is required': 'Il ruolo è obbligatorio',
    'Description is required': 'La descrizione è obbligatoria',
    'Role saved': 'Ruolo salvato',
    'Unable to save role': 'Impossibile salvare il ruolo',
    'Delete is not available for roles.': 'L’eliminazione non è disponibile per i ruoli.',
    'Select a role': 'Seleziona un ruolo',
    'What this role can do': 'Cosa può fare questo ruolo',
    'Select the permissions granted to this role.': 'Seleziona i permessi concessi a questo ruolo.',
    'Add New User': 'Aggiungi nuovo utente',
    'A secure temporary password will be auto-generated and emailed to the user.':
      'Verrà generata automaticamente una password temporanea sicura e inviata all’utente via email.',
    'Prefill demo data': 'Compila dati demo',
    'First Name': 'Nome',
    'Last Name': 'Cognome',
    'Email': 'Email',
    'Initial Language': 'Lingua iniziale',
    'Use organization default': "Usa il valore predefinito dell'organizzazione",
    'Additional Roles': 'Ruoli aggiuntivi',
    'Title (optional)': 'Titolo (opzionale)',
    'Phone (optional)': 'Telefono (opzionale)',
    'Create User': 'Crea utente',
    'Creating...': 'Creazione in corso...',
    'Edit User': 'Modifica utente',
    'Title': 'Titolo',
    'Phone': 'Telefono',
    'Active user': 'Utente attivo',
    'Profile Association': 'Associazione profilo',
    'Linked As': 'Collegato come',
    'Not linked': 'Non collegato',
    'Provider': 'Medico',
    'Staff': 'Staff',
    'Provider Profile': 'Profilo medico',
    'Auto-create or use linked provider': 'Crea automaticamente o usa il medico collegato',
    'Provider Type (optional override)': 'Tipo medico (override opzionale)',
    Coordination: 'Coordinamento',
    'Care Episodes': 'Episodi di cura',
    'Current and past episodes in one workspace table.': 'Episodi attuali e passati in un\'unica tabella di lavoro.',
    'No episodes created yet.': 'Nessun episodio creato ancora.',
    'New Episode': 'Nuovo episodio',
    'Receptionist': 'Receptionist',
    'Staff Profile': 'Profilo staff',
    'Auto-create or use linked staff': 'Crea automaticamente o usa lo staff collegato',
    'Staff Role (optional override)': 'Ruolo staff (override opzionale)',
    'Reset Password?': 'Reimpostare la password?',
    'Reset password for': 'Reimposta password per',
    'A new temporary password will be emailed.': 'Verrà inviata via email una nuova password temporanea.',
    'Confirm Reset': 'Conferma reimpostazione',
    'Resetting...': 'Reimpostazione in corso...',
    'User Management': 'Gestione utenti',
    'Manage system access and accounts.': 'Gestisci accessi e account di sistema.',
    'Add User': 'Aggiungi utente',
    'Only administrators can access User Management.': 'Solo gli amministratori possono accedere alla gestione utenti.',
    'Unable to load current user role.': 'Impossibile caricare il ruolo dell’utente corrente.',
    'Loading users...': 'Caricamento utenti...',
    'Only administrators can view and manage users.': 'Solo gli amministratori possono visualizzare e gestire gli utenti.',
    'Search users...': 'Cerca utenti...',
    'Linked Profile': 'Profilo collegato',
    'Reset password': 'Reimposta password',
    'Edit user': 'Modifica utente',
    'Archive user': 'Archivia utente',
    'User created. Temporary password was sent by email.': 'Utente creato. La password temporanea è stata inviata via email.',
    'User updated successfully.': 'Utente aggiornato con successo.',
    'Temporary password reset email sent.': 'Email di reimpostazione password temporanea inviata.',
    'User archived successfully.': 'Utente archiviato con successo.',
    'Failed to create user.': 'Impossibile creare l’utente.',
    'Failed to update user.': 'Impossibile aggiornare l’utente.',
    'Failed to reset password.': 'Impossibile reimpostare la password.',
    'Failed to archive user.': 'Impossibile archiviare l’utente.',
    'Failed to load user management.': 'Impossibile caricare la gestione utenti.',
    'Unable to load user management.': 'Impossibile caricare la gestione utenti.',
    'Unable to load users.': 'Impossibile caricare gli utenti.',
    'Unable to load roles.': 'Impossibile caricare i ruoli.',
    'Unable to load provider profiles.': 'Impossibile caricare i profili medici.',
    'Unable to load staff profiles.': 'Impossibile caricare i profili staff.',
    'Please select a role.': 'Seleziona un ruolo.',
    'Select role': 'Seleziona un ruolo',
    'Doctor': 'Medico',
    'Archive user {name}? This will also remove their Cognito identity.': "Archiviare l'utente {name}? Questo rimuoverà anche la sua identità Cognito.",
    'This will also remove their Cognito identity.': 'Questo rimuoverà anche la loro identità Cognito.',
    'Failed to update user profile association.': 'Impossibile aggiornare l’associazione del profilo utente.',
    'Monitor approvals, review queues, QA samples, blocked decisions, and the exact recommendation context behind each AI action.':
      'Monitora approvazioni, code di revisione, campioni QA, decisioni bloccate e il contesto esatto della raccomandazione dietro ogni azione IA.',
    'AI Decision Queue': 'Coda decisioni IA',
    'Review all monitored AI actions using the same table-first workflow as operational modules.':
      'Rivedi tutte le azioni IA monitorate usando lo stesso flusso incentrato sulla tabella dei moduli operativi.',
    'Search AI decisions...': 'Cerca decisioni IA...',
    'All Decisions': 'Tutte le decisioni',
    'Approval Queue': 'Coda approvazioni',
    'Review Queue': 'Coda revisioni',
    'QA Queue': 'Coda QA',
    'No AI decisions matched the current queue.': 'Nessuna decisione IA corrisponde alla coda corrente.',
    'Select an AI decision to inspect the suggestion, policy context, and human actions.':
      'Seleziona una decisione IA per esaminare il suggerimento, il contesto della policy e le azioni umane.',
    'Why This Recommendation': 'Perché questa raccomandazione',
    'No explanation details captured.': 'Nessun dettaglio esplicativo acquisito.',
    'AI Suggestion Summary': 'Riepilogo del suggerimento IA',
    'AI Request Context': 'Contesto della richiesta IA',
    'Governance Actions': 'Azioni di governance',
    'Reviewer notes, rejection rationale, or QA comments': 'Note del revisore, motivazione del rifiuto o commenti QA',
    'Failed to load AI governance workspace.': 'Impossibile caricare il workspace governance IA.',
    'Failed to refresh AI governance workspace.': 'Impossibile aggiornare il workspace governance IA.',
    'Failed to update AI governance state.': 'Impossibile aggiornare lo stato governance IA.',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;

type PhraseTable = Record<string, string>;

const phraseTranslations: Record<SupportedLanguage, PhraseTable> = {
  en: {},
  es: {
    'Loading...': 'Cargando...',
    'Redirecting to login...': 'Redirigiendo al inicio de sesión...',
    'Auth error': 'Error de autenticación',
    'Loading patient...': 'Cargando paciente...',
    'Patient not found': 'Paciente no encontrado',
    'Back to patients': 'Volver a pacientes',
    'Patient Details': 'Detalles del paciente',
    'Back to list': 'Volver a la lista',
    Edit: 'Editar',
    Save: 'Guardar',
    'Saving...': 'Guardando...',
    Cancel: 'Cancelar',
    Close: 'Cerrar',
    'Choose the audit depth, what AI workflows are monitored, and which safeguards stay active.':
      'Elige la profundidad de auditoría, qué flujos de IA se monitorizan y qué salvaguardas permanecen activas.',
    'Save Settings': 'Guardar configuración',
    'AI governance settings saved.': 'La configuración de gobernanza de IA se guardó correctamente.',
    'Failed to load AI governance settings.': 'No se pudieron cargar los ajustes de gobernanza de IA.',
    'Failed to save AI governance settings.': 'No se pudieron guardar los ajustes de gobernanza de IA.',
    'Audit Policy': 'Política de auditoría',
    'Control how aggressively Elen1 captures, samples, and governs AI activity.':
      'Controla con qué nivel de rigor Elen1 captura, muestrea y gobierna la actividad de IA.',
    'Audit level': 'Nivel de auditoría',
    Minimal: 'Mínimo',
    Standard: 'Estándar',
    Strict: 'Estricto',
    'Capture request summaries': 'Capturar resúmenes de solicitudes',
    'Capture response summaries': 'Capturar resúmenes de respuestas',
    'Capture explanation details': 'Capturar detalles de explicación',
    'Require approval for high-risk actions': 'Requerir aprobación para acciones de alto riesgo',
    'Require review for medium-risk actions': 'Requerir revisión para acciones de riesgo medio',
    'Enable QA sampling': 'Activar muestreo de QA',
    'Monitored Actions': 'Acciones monitorizadas',
    'Decide exactly which AI workflows are monitored and which ones require a durable audit trail.':
      'Decide exactamente qué flujos de IA se monitorizan y cuáles requieren un registro de auditoría persistente.',
    Workflow: 'Flujo',
    Monitor: 'Monitorizar',
    Audit: 'Auditar',
    'No AI workflows are registered yet.': 'Todavía no hay flujos de IA registrados.',
    Overview: 'Resumen',
    Prescription: 'Receta',
    Prescriptions: 'Recetas',
    Documents: 'Documentos',
    Medications: 'Medicaciones',
    Vaccinations: 'Vacunas',
    Clinical: 'Clínico',
    Notes: 'Notas',
    'Medical Forms': 'Formularios médicos',
    'Treatment Plans': 'Planes de tratamiento',
    Monitoring: 'Monitoreo',
    'Portal Access': 'Acceso al portal',
    Invoices: 'Facturas',
    Visits: 'Visitas',
    Billing: 'Facturación',
    'sidebar.promotions': 'Promociones',
    'sidebar.packages': 'Paquetes',
    'sidebar.loyalty': 'Lealtad',
    'sidebar.pos': 'POS',
    'sidebar.staffOperations': 'Operaciones de personal',
    'sidebar.timesheets': 'Hojas de tiempo',
    'sidebar.mobileCapture': 'Captura movil',
    'sidebar.inventory': 'Inventario',
    'sidebar.advancedInventory': 'Inventario avanzado',
    'sidebar.marketing': 'Marketing',
    'sidebar.audit': 'Auditoría',
    Telemedicine: 'Telemedicina',
    Allergies: 'Alergias',
    Problems: 'Problemas',
    'None listed': 'Ninguno',
    Provider: 'Profesional',
    'No visits yet': 'Aún sin visitas',
    'Search patient name or MRN': 'Buscar nombre del paciente o MRN',
    'No patients found': 'No se encontraron pacientes',
    'Loading patients...': 'Cargando pacientes...',
    'Loading patient details...': 'Cargando detalles del paciente...',
    'Loading portal access...': 'Cargando acceso al portal...',
    'Select a patient to begin prescribing.': 'Selecciona un paciente para comenzar a recetar.',
    'Select a patient to start billing.': 'Selecciona un paciente para comenzar la facturación.',
    'Manual Tests': 'Pruebas manuales',
    'Add allergy': 'Agregar alergia',
    'Add problem': 'Agregar problema',
    'Add medication': 'Agregar medicamento',
    with: 'con',
    'No upcoming visits': 'No hay visitas proximas',
    Timeline: 'Linea de tiempo',
    'No appointment history yet.': 'Aun no hay historial de citas.',
    'Portal access active': 'Acceso al portal activo',
    'Portal access not active': 'Acceso al portal no activo',
    'Patient portal identity': 'Identidad del portal del paciente',
    'Portal email': 'Correo del portal',
    'Portal language': 'Idioma del portal',
    'Password state': 'Estado de la contrasena',
    Ready: 'Listo',
    Linked: 'Vinculado',
    'Request failed': 'Solicitud fallida',
    'Activate portal access': 'Activar acceso al portal',
    'Send new credentials': 'Enviar nuevas credenciales',
    'Open portal login': 'Abrir acceso al portal',
    'Linked portal user': 'Usuario del portal vinculado',
    'Access timeline': 'Cronologia de acceso',
    'Last password change': 'Ultimo cambio de contrasena',
    'Last account update': 'Ultima actualizacion de la cuenta',
    'Password reset required': 'Se requiere restablecer la contrasena',
    'Cognito provisioning pending': 'Provisionamiento de Cognito pendiente',
    Provisioned: 'Provisionado',
    'Not provisioned': 'No provisionado',
    'Active user': 'Usuario activo',
    'Inactive user': 'Usuario inactivo',
    'Credentials sent': 'Credenciales enviadas',
    'Create the patient portal account, provision the Cognito identity, and send a temporary password.':
      'Crea la cuenta del portal del paciente, provisiona la identidad de Cognito y envia una contrasena temporal.',
    'Send a new temporary password to the linked patient portal account.':
      'Envia una nueva contrasena temporal a la cuenta del portal del paciente ya vinculada.',
    'The portal email is locked after activation to avoid desynchronizing the linked Cognito identity.':
      'El correo del portal queda bloqueado despues de la activacion para evitar desincronizar la identidad vinculada de Cognito.',
    'Portal access was activated, but email delivery is currently in mock mode.':
      'El acceso al portal se activo, pero el envio de correo esta actualmente en modo simulado.',
    'Portal credentials were sent successfully.': 'Las credenciales del portal se enviaron correctamente.',
    'New portal credentials were sent successfully.': 'Las nuevas credenciales del portal se enviaron correctamente.',
    'A temporary password was generated, but email delivery is currently in mock mode.':
      'Se genero una contrasena temporal, pero el envio de correo esta actualmente en modo simulado.',
    'Failed to load portal access': 'No se pudo cargar el acceso al portal',
    'Failed to activate portal access': 'No se pudo activar el acceso al portal',
    'Failed to send portal credentials': 'No se pudieron enviar las credenciales del portal',
    'Patient portal routes are disabled in this environment. Activation can be prepared, but portal sign-in will remain unavailable until the portal is enabled.':
      'Las rutas del portal del paciente estan deshabilitadas en este entorno. La activacion puede prepararse, pero el acceso al portal seguira sin estar disponible hasta que se habilite.',
    'Cognito user provisioning is disabled. Enable it before activating portal access.':
      'El aprovisionamiento de usuarios en Cognito esta deshabilitado. Activalo antes de activar el acceso al portal.',
    'Visits trend': 'Tendencia de visitas',
    Upcoming: 'Proximas',
    Date: 'Fecha',
    'Title / Type': 'Titulo / Tipo',
    Duration: 'Duracion',
    'No appointments recorded.': 'No hay citas registradas.',
    Televisits: 'Televisitas',
    'New Televisit': 'Nueva teleconsulta',
    Televisit: 'Teleconsulta',
    'No telemedicine appointments recorded.': 'No hay citas de telemedicina registradas.',
    'Edit patient': 'Editar paciente',
    'City / Location': 'Ciudad / Ubicacion',
    State: 'Estado',
    'Postal code': 'Codigo postal',
    'Insurance provider': 'Aseguradora',
    'Insurance member ID': 'ID de miembro del seguro',
    'Insurance group #': 'Grupo de seguro #',
    'Emergency contact name': 'Nombre de contacto de emergencia',
    'Emergency contact phone': 'Telefono de contacto de emergencia',
    'Quick add': 'Agregar rapido',
    'Search medication to add': 'Buscar medicamento para agregar',
    'New allergy': 'Nueva alergia',
    'New problem': 'Nuevo problema',
    'New medication': 'Nuevo medicamento',
    'Failed to save': 'No se pudo guardar',
    'Edit event': 'Editar evento',
    Add: 'Agregar',
    Select: 'Seleccionar',
    'Failed to load manual tests.': 'No se pudieron cargar las pruebas manuales.',
    'Image uploaded.': 'Imagen cargada.',
    'Image upload failed.': 'Fallo la carga de imagen.',
    'Upload an image before running AI analysis.': 'Sube una imagen antes de ejecutar el analisis de IA.',
    'AI analyzed image': 'Imagen analizada por IA',
    confidence: 'confianza',
    'confidence not provided': 'confianza no proporcionada',
    'AI analysis applied.': 'Analisis de IA aplicado.',
    'AI analysis failed.': 'Fallo el analisis de IA.',
    'Select a test type before saving.': 'Selecciona un tipo de prueba antes de guardar.',
    'Manual test entry saved.': 'Registro de prueba manual guardado.',
    'Failed to save manual test entry.': 'No se pudo guardar el registro de prueba manual.',
    'Delete this manual test entry?': 'Eliminar este registro de prueba manual?',
    'Entry deleted.': 'Registro eliminado.',
    'Failed to delete entry.': 'No se pudo eliminar el registro.',
    'Unable to open image.': 'No se puede abrir la imagen.',
    'Loading manual tests...': 'Cargando pruebas manuales...',
    'Image and strip-based patient tests': 'Pruebas de paciente basadas en imagen y tiras',
    'Definitions come from Settings. Upload test images and optionally let AI classify the result.':
      'Las definiciones vienen de Configuracion. Sube imagenes de prueba y opcionalmente permite que IA clasifique el resultado.',
    'Add Manual Test': 'Agregar prueba manual',
    'Recorded Manual Tests': 'Pruebas manuales registradas',
    Test: 'Prueba',
    'No manual tests recorded yet.': 'Aun no hay pruebas manuales registradas.',
    'Add Manual Test Entry': 'Agregar registro de prueba manual',
    'Analyzing...': 'Analizando...',
    'AI Analyze Image': 'Analizar imagen con IA',
    'Test Type': 'Tipo de prueba',
    'Select test': 'Seleccionar prueba',
    'Measured At': 'Medido en',
    'Value (text)': 'Valor (texto)',
    'Trace / Moderate / etc': 'Traza / Moderado / etc',
    'Value (number)': 'Valor (numero)',
    Unit: 'Unidad',
    Category: 'Categoria',
    'Uploading...': 'Subiendo...',
    'Upload Image': 'Subir imagen',
    'No image': 'Sin imagen',
    'Save Entry': 'Guardar registro',
    'Core Clinical': 'Nucleo clinico',
    Financial: 'Financiero',
    'Telemed + Remote Care': 'Telemedicina + atencion remota',
    'Clinic Admin': 'Administracion clinica',
    'Walk-ins': 'Ingresos sin cita',
    'Rapid triage, quick intake, and fast visit routing.': 'Triage rapido, ingreso agil y enrutamiento rapido de visitas.',
    'Lab/Imaging': 'Laboratorio/Imagenes',
    'Real-time results triage board with quick actions.': 'Panel de triage de resultados en tiempo real con acciones rapidas.',
    'Genomic Data Integration': 'Integracion de datos genomicos',
    'Link variants with phenotype and treatment paths.': 'Vincula variantes con fenotipo y rutas de tratamiento.',
    'Universal Search': 'Busqueda universal',
    'Search patients, labs, meds, invoices in one box.': 'Busca pacientes, laboratorios, medicamentos y facturas en una sola caja.',
    'Room Management': 'Gestion de habitaciones',
    'Assign rooms, track occupancy, and cleaning state.': 'Asigna habitaciones y rastrea ocupacion y estado de limpieza.',
    'Claims Retry Engine': 'Motor de reintento de reclamos',
    'Auto-detect denials and smart resubmits.': 'Detecta denegaciones y reenvios inteligentes automaticamente.',
    'Billing Rules Engine': 'Motor de reglas de facturacion',
    'Payer/procedure-specific rules and guardrails.': 'Reglas y controles por pagador/procedimiento.',
    'Subscription / Membership': 'Suscripcion / Membresia',
    'Recurring plans, auto-charges, benefits tracking.': 'Planes recurrentes, cobros automaticos y seguimiento de beneficios.',
    'Revenue Insights Dashboard': 'Panel de insights de ingresos',
    'Collections, AR aging, payer mix at a glance.': 'Cobros, antiguedad de cuentas por cobrar y mezcla de pagadores de un vistazo.',
    'Asynchronous Visits': 'Visitas asincronas',
    'Store-and-forward uploads with clinician responses.': 'Carga y reenvio de archivos con respuestas del clinico.',
    'active device program(s)': 'programa(s) de dispositivo activo(s)',
    'Last data': 'Ultimos datos',
    'No readings yet': 'Aun no hay lecturas',
    'Trend Signals': 'Senales de tendencia',
    'No metric history yet. Ingest or simulate readings to render trend lines.':
      'Aun no hay historial de metricas. Ingiere o simula lecturas para mostrar las lineas de tendencia.',
    'Device Enrollment': 'Inscripcion del dispositivo',
    'Enroll Device': 'Inscribir dispositivo',
    'Patient Enrollments': 'Inscripciones del paciente',
    'Manual Reading Ingest': 'Ingestion manual de lecturas',
    'Add Reading': 'Agregar lectura',
    'Recent incoming updates': 'Actualizaciones entrantes recientes',
    'No readings yet.': 'Aun no hay lecturas.',
    'AI Call Summaries': 'Resumenes de llamadas con IA',
    'Summaries → structured notes → billing suggestions.': 'Resumenes -> notas estructuradas -> sugerencias de facturacion.',
    'Summaries -> structured notes -> billing suggestions.': 'Resumenes -> notas estructuradas -> sugerencias de facturacion.',
    'Virtual Waiting Room': 'Sala de espera virtual',
    'Recent telemedicine visits, patient intake, and instant room launch in one workspace.':
      'Visitas recientes de telemedicina, admision de pacientes y apertura instantanea de sala en un solo espacio.',
    'Pre-call ID check and queue visibility.': 'Verificacion de identidad previa a la llamada y visibilidad de la cola.',
    'Inventory + Auto-Reorder': 'Inventario + reorden automatico',
    'Stock levels, expiries, vendor reorders.': 'Niveles de stock, vencimientos y reordenes a proveedores.',
    'Pharmacy Dispensing': 'Dispensacion de farmacia',
    'Dispense tracking, labels, lot/expiration.': 'Seguimiento de dispensacion, etiquetas y lote/vencimiento.',
    'Reports Builder': 'Constructor de reportes',
    'Custom dashboards and exports.': 'Dashboards personalizados y exportaciones.',
    'Telemed Room': 'Sala de telemedicina',
    'Cancel Telemed': 'Cancelar telemedicina',
    "Today's Telemed Visits": 'Visitas de telemedicina de hoy',
    'Join or copy links directly.': 'Únete o copia enlaces directamente.',
    Refresh: 'Actualizar',
    'Search patient, provider, type...': 'Buscar paciente, profesional, tipo...',
    'All statuses': 'Todos los estados',
    Waiting: 'En espera',
    'In session': 'En sesión',
    Finished: 'Finalizado',
    Patient: 'Paciente',
    Open: 'Abrir',
    Time: 'Hora',
    'Visit type': 'Tipo de visita',
    Status: 'Estado',
    Actions: 'Acciones',
    Join: 'Unirse',
    Link: 'Enlace',
    Email: 'Correo',
    'Loading telemed visits.': 'Cargando visitas de telemedicina.',
    'No telemed visits found.': 'No se encontraron visitas de telemedicina.',
    'Join as provider (host)': 'Unirse como profesional (anfitrión)',
    'Copy patient link': 'Copiar enlace del paciente',
    'Send email invite': 'Enviar invitación por correo',
    'Join Guidance': 'Guía de acceso',
    'Use host token for providers; guest token for patients.': 'Usa token de anfitrión para profesionales y token de invitado para pacientes.',
    'Provider (host)': 'Profesional (anfitrión)',
    Guest: 'Invitado',
    'Start Live Transcription': 'Iniciar transcripción en vivo',
    'Stop Live Transcription': 'Detener transcripción en vivo',
    'No transcript yet': 'Sin transcripción aún',
    'Preparing call...': 'Preparando llamada...',
    'Live AI Diagnostics': 'Diagnósticos IA en vivo',
    'Run diagnostics now': 'Ejecutar diagnóstico ahora',
    'Auto diagnostics': 'Diagnóstico automático',
    'Clinical Notes': 'Notas clínicas',
    'Type live clinical observations, exam findings, and plan...':
      'Escribe observaciones clínicas en vivo, hallazgos de examen y plan...',
    'Saving notes...': 'Guardando notas...',
    Saved: 'Guardado',
    'Speech recognition is not supported in this browser. Use Chrome or Edge.':
      'El reconocimiento de voz no es compatible con este navegador. Usa Chrome o Edge.',
    'Transcription error occurred.': 'Ocurrió un error de transcripción.',
    'Unable to start transcription.': 'No se pudo iniciar la transcripción.',
    'Unable to update transcript segment.': 'No se pudo actualizar el segmento de transcripción.',
    'Failed to create telemed session': 'No se pudo crear la sesión de telemedicina',
    'Failed to join call': 'No se pudo unir a la llamada',
    'Failed to sync transcript chunk.': 'No se pudo sincronizar el fragmento de transcripción.',
    'Failed to run live diagnostics.': 'No se pudo ejecutar el diagnóstico en vivo.',
    'Failed to save clinical notes.': 'No se pudieron guardar las notas clínicas.',
    'Failed to end telemedicine visit.': 'No se pudo finalizar la visita de telemedicina.',
    'Visit ended. Telemedicine summary was added to the patient notes.':
      'Visita finalizada. El resumen de telemedicina se agregó a las notas del paciente.',
    'Unknown sex': 'Sexo desconocido',
    'AI Summary': 'Resumen de IA',
    'Longitudinal Clinical Snapshot': 'Resumen clínico longitudinal',
    cached: 'en caché',
    'Rebuild summary now': 'Regenerar resumen ahora',
    'Building chart summary...': 'Generando resumen de historia...',
    Refreshing: 'Actualizando',
    Highlights: 'Puntos clave',
    'Risk Flags': 'Riesgos',
    'Care Gaps': 'Brechas de cuidado',
    'No summary available yet.': 'Aún no hay resumen disponible.',
    'No join link available to email.': 'No hay enlace disponible para enviar por correo.',
    'Failed to send email': 'No se pudo enviar el correo',
    'Failed to load telemed visits': 'No se pudieron cargar las visitas de telemedicina',
    'Unable to generate patient AI summary.': 'No se pudo generar el resumen de IA del paciente.',
    'None flagged': 'Sin alertas',
    'Failed to load patient': 'No se pudo cargar el paciente',
    Back: 'Volver',
    Role: 'Rol',
    'Clinical Visit Room': 'Sala de consulta clínica',
    'Telemed room for selected patient below.': 'Sala de telemedicina para el paciente seleccionado a continuacion.',
    'Instant meeting': 'Reunion instantanea',
    'Launch Virtual Room': 'Abrir sala virtual',
    'Create a telemedicine appointment instantly and open the provider room.':
      'Crea una cita de telemedicina al instante y abre la sala del profesional.',
    'Start instant meeting': 'Iniciar reunion instantanea',
    'Auto-selected from your current schedule': 'Seleccionado automaticamente de tu agenda actual',
    'No telemedicine appointment type configured': 'No hay un tipo de cita de telemedicina configurado',
    'Uses the configured default duration': 'Usa la duracion predeterminada configurada',
    'Start telemed': 'Iniciar telemedicina',
    'Search for an existing patient to start this telemedicine meeting.':
      'Busca un paciente existente para iniciar esta reunion de telemedicina.',
    'Search by name, MRN, or phone...': 'Buscar por nombre, MRN o telefono...',
    'Select a patient to start an instant meeting.': 'Selecciona un paciente para iniciar una reunion instantanea.',
    'No provider available for this instant meeting.': 'No hay un profesional disponible para esta reunion instantanea.',
    'No telemedicine appointment type is configured.': 'No hay un tipo de cita de telemedicina configurado.',
    'AI Clinical Analysis': 'Análisis clínico con IA',
    'End Visit & Save Summary': 'Finalizar visita y guardar resumen',
    'Connecting to Daily...': 'Conectando a Daily...',
    'Patient Briefing': 'Resumen del paciente',
    'Patient context unavailable.': 'Contexto del paciente no disponible.',
    'Live Transcription': 'Transcripcion en vivo',
    'Final transcript chunks are editable for 2 minutes.': 'Los fragmentos finales de la transcripción se pueden editar durante 2 minutos.',
    Updated: 'Actualizado',
    'Start live transcription to capture the consultation.': 'Inicia la transcripción en vivo para capturar la consulta.',
    'Auto-saved and included in AI diagnostics.': 'Guardado automáticamente e incluido en el diagnóstico de IA.',
    'Save failed': 'Error al guardar',
    Idle: 'En espera',
    'Live Diagnostics': 'Diagnosticos en vivo',
    'AI analysis from transcript + notes.': 'Análisis de IA a partir de la transcripción y notas.',
    'Auto-run': 'Ejecución automática',
    'Running clinical analysis...': 'Ejecutando análisis clínico...',
    'No diagnostics yet. Add transcript/notes then run analysis.': 'Aún no hay diagnóstico. Agrega transcripción/notas y luego ejecuta el análisis.',
    Summary: 'Resumen',
    Confidence: 'Confianza',
    'Red Flags': 'Señales de alarma',
    Action: 'Acción',
    Differential: 'Diagnóstico diferencial',
    'Missing Questions': 'Preguntas faltantes',
    'Suggested Next Steps': 'Próximos pasos sugeridos',
    minutes: 'minutos',
    Male: 'Masculino',
    Female: 'Femenino',
    Other: 'Otro',
    Clinician: 'Clinico',
    Unspecified: 'No especificado',
    'Failed to load patient briefing card.': 'No se pudo cargar la tarjeta de resumen del paciente.',
    'Failed to load live telemedicine state.': 'No se pudo cargar el estado en vivo de telemedicina.',
    'Transcription error': 'Error de transcripción',
    '1) Use the join link & host token from the appointment to start the call.':
      '1) Usa el enlace de acceso y el token de anfitrión de la cita para iniciar la llamada.',
    '2) Patients join with guest token or plain link if allowed.':
      '2) Los pacientes se unen con token de invitado o enlace directo si está permitido.',
    '3) End visit in the appointment to invalidate tokens.':
      '3) Finaliza la visita en la cita para invalidar los tokens.',
    'N/A': 'N/D',
    'Reports Dashboard': 'Panel de reportes',
    'Reports and analytics coming soon.': 'Reportes y análisis disponibles pronto.',
    'Execution Mix': 'Mezcla de ejecucion',
    'AI Query Activity (7 days)': 'Actividad de consultas IA (7 dias)',
    'Preset and custom report operations across saved, scheduled, and AI-assisted workflows.':
      'Operaciones de reportes predefinidos y personalizados en flujos guardados, programados y asistidos por IA.',
    'Schedule Health': 'Salud de programacion',
    'Custom Reports': 'Reportes personalizados',
    'Preset Reports': 'Reportes predefinidos',
    'AI Queries (24h)': 'Consultas IA (24 h)',
    'Custom Report Builder card': 'Tarjeta de constructor de reportes personalizados',
    Generated: 'Generado',
    Next: 'Siguiente',
    'Last visit': 'Última visita',
    DOB: 'FN',
    yrs: 'años',
    'High risk': 'Alto riesgo',
    Appointments: 'Citas',
    'Schedule Board': 'Panel de agenda',
    'Schedule tools': 'Herramientas de agenda',
    Calendar: 'Calendario',
    Prev: 'Anterior',
    'New Appointment': 'Nueva cita',
    Providers: 'Profesionales',
    'No providers': 'Sin profesionales',
    'Loading appointments...': 'Cargando citas...',
    Preview: 'Vista previa',
    Download: 'Descargar',
    Delete: 'Eliminar',
    'Day view': 'Vista diaria',
    'Week view': 'Vista semanal',
    day: 'día',
    week: 'semana',
    month: 'mes',
    appt: 'cita',
    Appointment: 'Cita',
    Scheduled: 'Programada',
    'Checked-in': 'Registrada',
    Completed: 'Completada',
    Cancelled: 'Cancelada',
    'No-show': 'Ausente',
    'Failed to load appointments': 'No se pudieron cargar las citas',
    'Failed to load patients': 'No se pudieron cargar los pacientes',
    'Failed to update appointment': 'No se pudo actualizar la cita',
    'Failed to save appointment': 'No se pudo guardar la cita',
    'Unable to load patient documents.': 'No se pudieron cargar los documentos del paciente.',
    'Failed to open document preview.': 'No se pudo abrir la vista previa del documento.',
    'Unable to fetch document download URL.': 'No se pudo obtener la URL de descarga del documento.',
    'Document deleted.': 'Documento eliminado.',
    'Failed to delete document.': 'No se pudo eliminar el documento.',
    '1 document uploaded successfully.': '1 documento subido correctamente.',
    'documents uploaded successfully.': 'documentos subidos correctamente.',
    'Document upload failed.': 'La carga del documento falló.',
    'Patient Document Viewer': 'Visor de documentos del paciente',
    'Upload files to S3, preview securely, and manage chart documents.': 'Sube archivos a S3, previsualiza de forma segura y gestiona documentos de la historia clínica.',
    'Upload Files': 'Subir archivos',
    'Stored Documents': 'Documentos guardados',
    'Loading documents...': 'Cargando documentos...',
    'Uploaded by': 'Subido por',
    'No documents uploaded for this patient.': 'No hay documentos cargados para este paciente.',
    'patient-document': 'documento-paciente',
    'Telemed session creation failed': 'No se pudo crear la sesión de telemedicina',
    'Join session': 'Unirse a la sesión',
    'Details of the appointment\'s patient': 'Detalles del paciente de la cita',
    'Change patient': 'Cambiar paciente',
    'Select a Patient': 'Seleccionar un paciente',
    'Search for an existing patient to schedule this appointment.':
      'Busca un paciente existente para programar esta cita.',
    'Appointment Details': 'Detalles de la cita',
    'Date, time, type, provider and status': 'Fecha, hora, tipo, profesional y estado',
    'Date & Time': 'Fecha y hora',
    'Appointment Type': 'Tipo de cita',
    'Appointment type': 'Tipo de cita',
    'Select provider': 'Seleccionar profesional',
    'Duration (minutes)': 'Duración (minutos)',
    'Title / Reason': 'Título / Motivo',
    'Telemed Details': 'Detalles de telemedicina',
    'Link and details on your telemedicine session': 'Enlace y detalles de tu sesión de telemedicina',
    'Before starting the telemedicine session, please ensure the patient understands that the consultation is being conducted remotely and may have limitations compared to an in-person exam.':
      'Antes de iniciar la sesión de telemedicina, asegúrate de que el paciente entiende que la consulta se realiza de forma remota y puede tener limitaciones frente a un examen presencial.',
    'Join link will be created when you save this appointment.': 'El enlace de acceso se creará cuando guardes esta cita.',
    'Join call': 'Unirse a la llamada',
    'Generate join link on save': 'Generar enlace de acceso al guardar',
    'Edit Appointment': 'Editar cita',
    'Request Appointment': 'Solicitar cita',
    min: 'min',
    PT: 'PT',
    'Drag blocks to reschedule • Hover for preview • Click empty space to create':
      'Arrastra bloques para reprogramar • Pasa el cursor para vista previa • Haz clic en un espacio vacío para crear',
    'Drag between days to reschedule': 'Arrastra entre días para reprogramar',
    Tomorrow: 'Mañana',
    'This week': 'Esta semana',
    'Clinical appointments and availability': 'Citas clínicas y disponibilidad',
    'Provider schedule and drag-to-reschedule': 'Agenda del profesional y arrastrar para reprogramar',
    'Month overview for scheduled appointments': 'Vista mensual de las citas programadas',
    'Selected day': 'Día seleccionado',
    Visible: 'Totales',
    'AI Auto Complete': 'Autocompletado IA',
    'AI Auto Complete failed.': 'Fallo el autocompletado IA.',
    'AI Clinical Summary': 'Resumen clinico IA',
    'AI analysis inserted. Please review and edit before signing.': 'Analisis IA insertado. Revisa y edita antes de firmar.',
    Accept: 'Aceptar',
    Dismiss: 'Descartar',
    'Add some note content before running AI Auto Complete.': 'Agrega contenido de nota antes de ejecutar Autocompletado IA.',
    'Patient Notes Workspace': 'Espacio de notas del paciente',
    'Rich note editor with live autocomplete and structured AI clinical completion.':
      'Editor de notas con autocompletado en vivo y completado clinico IA estructurado.',
    'New Note': 'Nueva nota',
    'Autocomplete On': 'Autocompletado activado',
    'Autocomplete Off': 'Autocompletado desactivado',
    'Live AI Suggestion On': 'Sugerencias IA en vivo activadas',
    'Live AI Suggestion Off': 'Sugerencias IA en vivo desactivadas',
    'Additional Questions': 'Preguntas adicionales',
    'Next Documentation Line': 'Siguiente linea de documentacion',
    'Prescription draft saved successfully.': 'Borrador de receta guardado correctamente.',
    'Prescription sent successfully.': 'Receta enviada correctamente.',
    'Search notes...': 'Buscar notas...',
    'Pinned only': 'Solo fijadas',
    'Loading notes...': 'Cargando notas...',
    'No content preview': 'Sin vista previa de contenido',
    'No notes found for this patient.': 'No se encontraron notas para este paciente.',
    'Note title': 'Titulo de nota',
    'Enter URL': 'Ingresa URL',
    Clear: 'Limpiar',
    'SOAP Template': 'Plantilla SOAP',
    'Pin note': 'Fijar nota',
    'Live AI suggestion': 'Sugerencia IA en vivo',
    'Thinking...': 'Pensando...',
    'Tip: press Tab to accept': 'Tip: presiona Tab para aceptar',
    'No suggestion yet. Add a few symptoms or findings.': 'Aun no hay sugerencias. Agrega algunos sintomas o hallazgos.',
    Author: 'Autor',
    Created: 'Creado',
    'Last updated': 'Ultima actualizacion',
    'Current user': 'Usuario actual',
    'Unable to load notes.': 'No se pudieron cargar las notas.',
    'You have unsaved note changes. Continue without saving?': 'Tienes cambios sin guardar en la nota. Continuar sin guardar?',
    'Image is too large. Maximum size is 3 MB per image.': 'La imagen es demasiado grande. El tamano maximo es 3 MB por imagen.',
    'Failed to read image file.': 'No se pudo leer el archivo de imagen.',
    'Image inserted into note.': 'Imagen insertada en la nota.',
    'Live AI suggestion is currently unavailable.': 'La sugerencia IA en vivo no esta disponible en este momento.',
    'Note content cannot be empty.': 'El contenido de la nota no puede estar vacio.',
    'Note created.': 'Nota creada.',
    'Note updated.': 'Nota actualizada.',
    'Failed to save note.': 'No se pudo guardar la nota.',
    'Delete this note? This action can be audited and hidden from active views.': 'Eliminar esta nota? Esta accion puede auditarse y ocultarse de vistas activas.',
    'Note deleted.': 'Nota eliminada.',
    'Failed to delete note.': 'No se pudo eliminar la nota.',
    'Replace current note content with SOAP template?': 'Reemplazar el contenido actual de la nota con la plantilla SOAP?',
    Subjective: 'Subjetivo',
    Objective: 'Objetivo',
    Assessment: 'Evaluacion',
    Plan: 'Plan',
    Bold: 'Negrita',
    Italic: 'Cursiva',
    Underline: 'Subrayado',
    'Bullet List': 'Lista con vietas',
    'Numbered List': 'Lista numerada',
    'Insert Image': 'Insertar imagen',
    'Insert Link': 'Insertar enlace',
    'Proposed Diagnoses': 'Diagnosticos propuestos',
    'Patient Forms Workspace': 'Espacio de formularios del paciente',
    'Assign reusable forms, complete in clinic, or send secure links to patients before arrival.':
      'Asigna formularios reutilizables, completalos en clinica o envia enlaces seguros a pacientes antes de llegar.',
    'No medical form instances for this patient yet.': 'No hay instancias de formularios medicos para este paciente todavia.',
    'Unable to load patient forms.': 'No se pudieron cargar los formularios del paciente.',
    'Unable to load selected form.': 'No se pudo cargar el formulario seleccionado.',
    'Create Form': 'Crear formulario',
    'Create Form Instance': 'Crear instancia de formulario',
    'Select a form template first.': 'Selecciona primero una plantilla de formulario.',
    'Form created and sent via': 'Formulario creado y enviado via',
    'Form instance created.': 'Instancia de formulario creada.',
    'Unable to create form instance.': 'No se pudo crear la instancia del formulario.',
    'Form marked complete.': 'Formulario marcado como completado.',
    'Form saved.': 'Formulario guardado.',
    'Failed to save form.': 'No se pudo guardar el formulario.',
    'Send form to email:': 'Enviar formulario por correo a:',
    'Form sent': 'Formulario enviado',
    'Sent to': 'Enviado a',
    'Unable to send form.': 'No se pudo enviar el formulario.',
    completed: 'completado',
    pending: 'pendiente',
    total: 'total',
    Completion: 'Completado',
    Due: 'Vence',
    'Loading forms...': 'Cargando formularios...',
    'Select a form instance to start filling.': 'Selecciona una instancia de formulario para comenzar a completar.',
    'Patient email (optional)': 'Correo del paciente (opcional)',
    'Send immediately by email': 'Enviar inmediatamente por correo',
    'Send Email': 'Enviar correo',
    Creating: 'Creando',
    'Creating...': 'Creando...',
    to: 'a',
    'Patient Treatment Planning Workspace': 'Espacio de planificacion de tratamiento del paciente',
    'Assign a settings-defined plan template and manage goals, interventions, medication, monitoring, and outcomes.':
      'Asigna una plantilla de plan definida en configuracion y gestiona metas, intervenciones, medicacion, monitoreo y resultados.',
    'Add treatment plan': 'Agregar plan de tratamiento',
    'Assigned Plans': 'Planes asignados',
    'No treatment plans assigned yet.': 'Aun no hay planes de tratamiento asignados.',
    'Select a treatment plan to edit.': 'Selecciona un plan de tratamiento para editar.',
    'Failed to load treatment plans.': 'No se pudieron cargar los planes de tratamiento.',
    'Select a treatment plan template.': 'Selecciona una plantilla de plan de tratamiento.',
    'Treatment plan assigned.': 'Plan de tratamiento asignado.',
    'Unable to create treatment plan.': 'No se pudo crear el plan de tratamiento.',
    'Treatment plan saved.': 'Plan de tratamiento guardado.',
    'Unable to save treatment plan.': 'No se pudo guardar el plan de tratamiento.',
    'Plan review logged.': 'Revision del plan registrada.',
    'Unable to mark review.': 'No se pudo marcar la revision.',
    'Delete treatment plan?': 'Eliminar plan de tratamiento?',
    'Treatment plan deleted.': 'Plan de tratamiento eliminado.',
    'Unable to delete treatment plan.': 'No se pudo eliminar el plan de tratamiento.',
    'Loading treatment plans...': 'Cargando planes de tratamiento...',
    'Mark Reviewed': 'Marcar revisado',
    'Next review': 'Proxima revision',
    'Assign Treatment Plan': 'Asignar plan de tratamiento',
    'Assign Plan': 'Asignar plan',
    inactive: 'inactivo',
    'Diagnosis (optional)': 'Diagnostico (opcional)',
    Title: 'Titulo',
    Priority: 'Prioridad',
    'Review Cadence (days)': 'Cadencia de revision (dias)',
    'Progress %': 'Progreso %',
    'Adherence %': 'Adherencia %',
    'Start Date': 'Fecha de inicio',
    'Target End Date': 'Fecha objetivo de finalizacion',
    'Next Review': 'Proxima revision',
    'Patient Instructions': 'Instrucciones para el paciente',
    'Clinician Notes': 'Notas del clinico',
    'Barriers (comma separated)': 'Barreras (separadas por coma)',
    'Outcomes (comma separated)': 'Resultados (separados por coma)',
    Goals: 'Metas',
    Metric: 'Metrica',
    Target: 'Objetivo',
    'Timeframe (days)': 'Plazo (dias)',
    Description: 'Descripcion',
    Interventions: 'Intervenciones',
    Frequency: 'Frecuencia',
    'Duration (days)': 'Duracion (dias)',
    'Owner Role': 'Rol responsable',
    Instructions: 'Instrucciones',
    Medication: 'Medicacion',
    Dose: 'Dosis',
    Route: 'Via',
    Indication: 'Indicacion',
    'Target Range': 'Rango objetivo',
    'Alert Threshold': 'Umbral de alerta',
    'Action If Out Of Range': 'Accion si esta fuera de rango',
    'Follow-Up': 'Seguimiento',
    Modality: 'Modalidad',
    'Interval (days)': 'Intervalo (dias)',
    Purpose: 'Proposito',
    Education: 'Educacion',
    Topic: 'Tema',
    Materials: 'Materiales',
    Required: 'Requerido',
    'Escalation Rules': 'Reglas de escalamiento',
    Trigger: 'Disparador',
    Severity: 'Severidad',
    'Care Team': 'Equipo de cuidado',
    'Member Name': 'Nombre del miembro',
    Responsibility: 'Responsabilidad',
    Contact: 'Contacto',
    'Remove row': 'Eliminar fila',
    'Patient Immunization Record': 'Registro de inmunizacion del paciente',
    'Capture administered/scheduled/refused vaccines with full traceability (lot, manufacturer, VIS, and next due date).':
      'Registra vacunas administradas/programadas/rechazadas con trazabilidad completa (lote, fabricante, VIS y proxima fecha).',
    'Vaccination History': 'Historial de vacunacion',
    'Next Due': 'Proxima dosis',
    'Loading vaccinations...': 'Cargando vacunaciones...',
    'Failed to load vaccination records.': 'No se pudieron cargar los registros de vacunacion.',
    'Vaccine name is required.': 'El nombre de la vacuna es obligatorio.',
    'Vaccination record updated.': 'Registro de vacunacion actualizado.',
    'Vaccination record added.': 'Registro de vacunacion agregado.',
    'Failed to save vaccination record.': 'No se pudo guardar el registro de vacunacion.',
    'Delete vaccination record?': 'Eliminar registro de vacunacion?',
    'Vaccination record deleted.': 'Registro de vacunacion eliminado.',
    'Failed to delete vaccination record.': 'No se pudo eliminar el registro de vacunacion.',
    Total: 'Total',
    'Administered/Historical': 'Administradas/Historicas',
    'Potentially Overdue': 'Posiblemente vencidas',
    Vaccine: 'Vacuna',
    'Lot / Manufacturer': 'Lote / Fabricante',
    'No vaccination records found.': 'No se encontraron registros de vacunacion.',
    'Vaccination Form': 'Formulario de vacunacion',
    'Edit Vaccination Record': 'Editar registro de vacunacion',
    'Add Vaccination Record': 'Agregar registro de vacunacion',
    'Vaccine Catalog': 'Catalogo de vacunas',
    'Select from catalog (optional)...': 'Seleccionar del catalogo (opcional)...',
    'Vaccine Name': 'Nombre de vacuna',
    'CVX Code': 'Codigo CVX',
    Disease: 'Enfermedad',
    'Administration Date': 'Fecha de administracion',
    'Recorded Date': 'Fecha de registro',
    'Dose Number': 'Numero de dosis',
    'Series Doses': 'Dosis de la serie',
    'Body Side': 'Lado del cuerpo',
    'Dose Volume': 'Volumen de dosis',
    'Dose Unit': 'Unidad de dosis',
    'Lot Number': 'Numero de lote',
    Expiration: 'Vencimiento',
    Manufacturer: 'Fabricante',
    'Administered By': 'Administrado por',
    Location: 'Ubicacion',
    'Funding Source': 'Fuente de financiamiento',
    'VIS Date': 'Fecha VIS',
    'VIS Edition Date': 'Fecha de edicion VIS',
    'Next Due Date': 'Fecha de proxima dosis',
    Source: 'Fuente',
    'External ID': 'ID externo',
    Booster: 'Refuerzo',
    'Booster dose': 'Dosis de refuerzo',
    Reaction: 'Reaccion',
    'Update Record': 'Actualizar registro',
    'Add Vaccine': 'Agregar vacuna',
    'Search vaccine, disease, lot...': 'Buscar vacuna, enfermedad, lote...',
    ADMINISTERED: 'Administrada',
    SCHEDULED: 'Programada',
    PARTIAL: 'Parcial',
    HISTORICAL: 'Historica',
    REFUSED: 'Rechazada',
    CONTRAINDICATED: 'Contraindicada',
    LEFT: 'Izquierdo',
    RIGHT: 'Derecho',
    BILATERAL: 'Bilateral',
    LOW: 'Baja',
    NORMAL: 'Normal',
    HIGH: 'Alta',
    URGENT: 'Urgente',
    DRAFT: 'Borrador',
    ACTIVE: 'Activo',
    ON_HOLD: 'En pausa',
    DISCONTINUED: 'Suspendido',
    SENT: 'Enviado',
    IN_PROGRESS: 'En progreso',
    EXPIRED: 'Vencido',
    low: 'baja',
    medium: 'media',
    high: 'alta',
    'Add New Prescription': 'Agregar nueva receta',
    'Patient Appointments': 'Citas del paciente',
    'Patient Televisits': 'Televisitas del paciente',
    Document: 'Documento',
    'Patient Documents': 'Documentos del paciente',
    'Add Document': 'Agregar documento',
    'Upload New Document': 'Subir nuevo documento',
    'Edit Document': 'Editar documento',
    File: 'Archivo',
    'Document Type': 'Tipo de documento',
    'Failed to load folders.': 'No se pudieron cargar las carpetas.',
    'Failed to load threads.': 'No se pudieron cargar las conversaciones.',
    'Failed to load conversation.': 'No se pudo cargar la conversación.',
    'Attachment upload failed.': 'La carga del archivo adjunto falló.',
    Attachment: 'Adjunto',
    'Failed to send message.': 'No se pudo enviar el mensaje.',
    'Attachment is unavailable.': 'El adjunto no está disponible.',
    'Failed to create thread.': 'No se pudo crear la conversación.',
    'Failed to move thread.': 'No se pudo mover la conversación.',
    'Failed to add patient tag.': 'No se pudo agregar la etiqueta del paciente.',
    'Failed to remove patient tag.': 'No se pudo quitar la etiqueta del paciente.',
    'Failed to create folder.': 'No se pudo crear la carpeta.',
    'Close compose': 'Cerrar redacción',
    Compose: 'Redactar',
    Inbox: 'Bandeja de entrada',
    'Loading folders...': 'Cargando carpetas...',
    Folders: 'Carpetas',
    'Create folder': 'Crear carpeta',
    'Search in folder': 'Buscar en la carpeta',
    Archive: 'Archivo',
    'Waiting on Patient': 'Esperando al paciente',
    'Loading threads...': 'Cargando conversaciones...',
    'No conversations in this folder.': 'No hay conversaciones en esta carpeta.',
    'Untitled conversation': 'Conversación sin título',
    'No messages yet': 'Aún no hay mensajes',
    Conversation: 'Conversación',
    'Select a conversation': 'Seleccionar una conversación',
    'Conversation participant': 'Participante de la conversación',
    'Loading conversation...': 'Cargando conversación...',
    'Select a thread to view messages.': 'Selecciona una conversación para ver los mensajes.',
    System: 'Sistema',
    Seen: 'Visto',
    'Write a message': 'Escribe un mensaje',
    Tag: 'Etiqueta',
    Emoji: 'Emoji',
    Attach: 'Adjuntar',
    More: 'Más',
    Sending: 'Enviando',
    'Sending...': 'Enviando...',
    Send: 'Enviar',
    'New message': 'Nuevo mensaje',
    Recipients: 'Destinatarios',
    'Search recipients': 'Buscar destinatarios',
    Subject: 'Asunto',
    'Patient tags': 'Etiquetas del paciente',
    'Search patients': 'Buscar pacientes',
    'Write the first message...': 'Escribe el primer mensaje...',
    'Tag records': 'Etiquetar registros',
    'Folder name': 'Nombre de la carpeta',
    Create: 'Crear',
    Browse: 'Examinar',
    'Upload Document': 'Subir documento',
    'Loading document types...': 'Cargando tipos de documento...',
    'No document types are configured yet. Create one in Settings before uploading typed documents.':
      'Todavia no hay tipos de documento configurados. Crea uno en Configuracion antes de subir documentos tipificados.',
    'Update the title, description, document type, and required metadata for this file.':
      'Actualiza el titulo, la descripcion, el tipo de documento y los metadatos obligatorios de este archivo.',
    'Document uploaded successfully.': 'Documento subido correctamente.',
    'Document updated successfully.': 'Documento actualizado correctamente.',
    'A file is required.': 'Se requiere un archivo.',
    'Title is required.': 'El titulo es obligatorio.',
    'Document type is required.': 'El tipo de documento es obligatorio.',
    'Selected document type is invalid.': 'El tipo de documento seleccionado no es valido.',
    'Unable to load document types.': 'No se pudieron cargar los tipos de documento.',
    Uploaded: 'Subido',
    Details: 'Detalles',
    Site: 'Sitio',
    'No room assigned': 'Sin sala asignada',
    'Schedulable assets': 'Recursos programables',
    'No assets configured in Settings > Schedule Assets':
      'No hay recursos configurados en Configuracion > Activos programables',
    'Add rooms in Settings > Schedule Assets. Resources with type Room, Suite, Bay, or Bed appear here.':
      'Agrega salas en Configuracion > Activos programables. Aqui aparecen los recursos con tipo Room, Suite, Bay o Bed.',
    'Annual Checkup': 'Chequeo anual',
    'Follow Up': 'Seguimiento',
    Consult: 'Consulta',
    Procedure: 'Procedimiento',
    'Instant Telemed': 'Telemedicina instantanea',
    Portal: 'Portal',
    Print: 'Imprimir',
    Histories: 'Historiales',
    'No active problems': 'No hay problemas activos',
    'No known allergies': 'No hay alergias conocidas',
    'Past medical: Hypertension (since 2016)': 'Antecedentes personales: Hipertension (desde 2016)',
    'Family: Father - HTN, Mother - T2DM': 'Familiares: Padre - HTA, Madre - DM2',
    'Social: Non-smoker, occasional alcohol': 'Social: No fumador, alcohol ocasional',
    'Vitals trend': 'Tendencia de signos vitales',
    'BP 128/78 | HR 72 | SpO2 98% (stable)': 'PA 128/78 | FC 72 | SpO2 98% (estable)',
    'No active medications.': 'No hay medicamentos activos.',
    All: 'Todos',
    Telemed: 'Telemedicina',
    // Provider scheduling manager (frontend/src/features/scheduling/ProviderSchedulingManager.tsx)
    'Provider Self-Scheduling': 'Autoprogramación del proveedor',
    'Build the provider-facing schedule first, then expose only generated patient-bookable slots. The raw agenda stays hidden from the portal.':
      'Primero define el horario del proveedor y luego expón solo los turnos generados que pueden reservar los pacientes. La agenda interna permanece oculta en el portal.',
    Reload: 'Recargar',
    'Save schedule': 'Guardar horario',
    'Scheduling for': 'Programación de',
    'Loading provider schedule...': 'Cargando el horario del proveedor...',
    'Booking Policy': 'Política de reservas',
    'These rules apply to portal slot generation and patient self-service actions.':
      'Estas reglas se aplican a la generación de turnos del portal y a las acciones de autogestión del paciente.',
    'Minimum advance notice': 'Aviso mínimo previo',
    'Max days in future': 'Máx. días en el futuro',
    'Cancel notice hours': 'Horas de aviso para cancelación',
    'Reschedule notice hours': 'Horas de aviso para reprogramación',
    'Allow same-day booking': 'Permitir reserva el mismo día',
    'Allow portal cancellation': 'Permitir cancelación en el portal',
    'Allow portal reschedule': 'Permitir reprogramación en el portal',
    'Enforce working hours for bookable windows': 'Aplicar horario laboral a las franjas reservables',
    'Recurring Availability': 'Disponibilidad recurrente',
    'Manage recurring availability in one table. Each row carries its weekday, date range, and recurrence interval, similar to Outlook-style recurrence patterns.':
      'Gestiona la disponibilidad recurrente en una sola tabla. Cada fila incluye el día de la semana, el rango de fechas y el intervalo de recurrencia, similar a los patrones de recurrencia de Outlook.',
    'All Recurring Availability': 'Toda la disponibilidad recurrente',
    'Working-hours rows and portal-bookable rows are managed together here.':
      'Las filas de horario laboral y las reservables en el portal se gestionan juntas aquí.',
    'Recurring working hours': 'Horario laboral recurrente',
    'Add new': 'Añadir nuevo',
    'Staff-facing working hours': 'Horario laboral interno',
    Slots: 'Turnos',
    'No recurring availability yet.': 'Todavía no hay disponibilidad recurrente.',
    'Date Overrides': 'Excepciones por fecha',
    'Use date-level actions to block time, add extra availability, or replace a day without exposing internal calendar detail.':
      'Usa acciones por fecha para bloquear tiempo, añadir disponibilidad extra o sustituir un día sin mostrar el detalle del calendario interno.',
    'Block day': 'Bloquear día',
    'Block time': 'Bloquear horario',
    'Add availability': 'Añadir disponibilidad',
    'Replace day': 'Reemplazar día',
    'Blocked all day': 'Bloqueado todo el día',
    Blocked: 'Bloqueado',
    'Block full day': 'Bloquear día completo',
    'Block range': 'Bloquear rango',
    Reason: 'Motivo',
    'Vacation, lunch, emergency block, meeting...': 'Vacaciones, almuerzo, bloqueo por emergencia, reunión...',
    'No override windows configured': 'No hay ventanas de excepción configuradas',
    Slot: 'Turno',
    'Add override window': 'Añadir ventana de excepción',
    'No date overrides yet. Use the quick actions above to block time or open extra availability.':
      'Todavía no hay excepciones por fecha. Usa las acciones rápidas de arriba para bloquear tiempo o abrir disponibilidad extra.',
    'Add new availability': 'Añadir disponibilidad nueva',
    'Base schedule': 'Horario base',
    'Recurring Working Hours': 'Horario laboral recurrente',
    "Staff-facing availability used as the provider's weekly foundation.":
      'Disponibilidad interna usada como base semanal del proveedor.',
    'Patient booking': 'Reserva de pacientes',
    'Portal Bookable Window': 'Ventana reservable en el portal',
    'Recurring bookable slots with visit-type, buffer, and visibility rules.':
      'Turnos reservables recurrentes con reglas de tipo de visita, margen y visibilidad.',
    'Pick the series you want to build, then configure the weekly recurrence in the planner.':
      'Elige la serie que quieres crear y luego configura la recurrencia semanal en el planificador.',
    'Weekly Planner': 'Planificador semanal',
    'Add working availability': 'Añadir disponibilidad laboral',
    'Edit working availability': 'Editar disponibilidad laboral',
    "Use an Outlook-style weekly recurrence pattern for the provider's base working hours.":
      'Usa un patrón de recurrencia semanal estilo Outlook para el horario laboral base del proveedor.',
    'Series summary': 'Resumen de la serie',
    'This series creates one recurring schedule row for each checked weekday.':
      'Esta serie crea una fila recurrente por cada día de la semana marcado.',
    Pattern: 'Patrón',
    Range: 'Rango',
    'Not set': 'No definido',
    'Schedule pattern': 'Patrón de horario',
    'Define the daily work block and weekly recurrence in one place.':
      'Define el bloque de trabajo diario y la recurrencia semanal en un solo lugar.',
    'Series status': 'Estado de la serie',
    Recurrence: 'Recurrencia',
    'Repeat every': 'Repetir cada',
    'week(s)': 'semana(s)',
    'Range of recurrence': 'Rango de recurrencia',
    'Set how long this series should remain active in the provider schedule.':
      'Define durante cuánto tiempo debe permanecer activa esta serie en el horario del proveedor.',
    'Save availability': 'Guardar disponibilidad',
    'Add portal availability': 'Añadir disponibilidad del portal',
    'Edit portal availability': 'Editar disponibilidad del portal',
    'Set a recurring patient-bookable series with the same weekly recurrence style used in Outlook meetings.':
      'Configura una serie recurrente reservable por pacientes con el mismo estilo de recurrencia semanal que usan las reuniones de Outlook.',
    'Portal bookable window': 'Ventana reservable en el portal',
    'Each checked weekday becomes its own recurring portal row, with one shared booking rule set.':
      'Cada día de la semana marcado se convierte en su propia fila recurrente del portal, con un único conjunto compartido de reglas de reserva.',
    'Appointment time': 'Hora de la cita',
    Max: 'Máx.',
    'Choose the visit setup and weekly recurrence in one combined section.':
      'Elige la configuración de la visita y la recurrencia semanal en una sola sección combinada.',
    'Booking rules and range': 'Reglas de reserva y rango',
    'Control slot behavior, visibility, and how long this recurring series stays active.':
      'Controla el comportamiento de los turnos, la visibilidad y cuánto tiempo permanece activa esta serie recurrente.',
    'Slot settings': 'Configuración de turnos',
    'Slot duration': 'Duración del turno',
    'Visibility and access': 'Visibilidad y acceso',
    'Existing patients only': 'Solo pacientes existentes',
    'Allow new patients': 'Permitir pacientes nuevos',
    'Allow outside working hours': 'Permitir fuera del horario laboral',
    'Select at least one weekday.': 'Selecciona al menos un día de la semana.',
    'Each checked day saves as its own recurring row.': 'Cada día marcado se guarda como su propia fila recurrente.',
    'No weekdays selected': 'No hay días seleccionados',
    'Every day': 'Todos los días',
    Weekdays: 'Días laborables',
    'Every week': 'Cada semana',
    Every: 'Cada',
    weeks: 'semanas',
    Day: 'Día',
    Sunday: 'Domingo',
    Monday: 'Lunes',
    Tuesday: 'Martes',
    Wednesday: 'Miércoles',
    Thursday: 'Jueves',
    Friday: 'Viernes',
    Saturday: 'Sábado',
    Sun: 'Dom',
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mié',
    Thu: 'Jue',
    Fri: 'Vie',
    Sat: 'Sáb',
    'Failed to load appointment types.': 'No se pudieron cargar los tipos de cita.',
    'Failed to load scheduling.': 'No se pudo cargar la programación.',
    'Failed to load scheduling configuration.': 'No se pudo cargar la configuración de programación.',
    'Failed to load day preview.': 'No se pudo cargar la vista previa del día.',
    'Failed to save scheduling.': 'No se pudo guardar la programación.',
    'Failed to save scheduling configuration.': 'No se pudo guardar la configuración de programación.',
    'Provider scheduling saved.': 'La programación del proveedor se guardó.',
    'Email alerts': 'Alertas por correo',
    'Task reminders': 'Recordatorios de tareas',
    'Appointment alerts': 'Alertas de citas',
    'Billing alerts': 'Alertas de facturación',
    'Compact mode': 'Modo compacto',
    Security: 'Seguridad',
    'Action required': 'Acción requerida',
    'Current Password': 'Contraseña actual',
    'New Password': 'Nueva contraseña',
    'Confirm New Password': 'Confirmar nueva contraseña',
    'Password guidance: use at least 12 characters with uppercase, lowercase, a number, and a symbol.':
      'Guía de contraseña: usa al menos 12 caracteres con mayúsculas, minúsculas, un número y un símbolo.',
    'Do not reuse your current password.': 'No reutilices tu contraseña actual.',
    'Update Password': 'Actualizar contraseña',
    'Password must be at least 12 characters long.': 'La contraseña debe tener al menos 12 caracteres.',
    'Password must include at least one uppercase letter.': 'La contraseña debe incluir al menos una letra mayúscula.',
    'Password must include at least one lowercase letter.': 'La contraseña debe incluir al menos una letra minúscula.',
    'Password must include at least one number.': 'La contraseña debe incluir al menos un número.',
    'Password must include at least one symbol.': 'La contraseña debe incluir al menos un símbolo.',
    'Enter your current password and type the new password twice.': 'Introduce tu contraseña actual y escribe la nueva contraseña dos veces.',
    Coordination: 'Coordinación',
    'Care Episodes': 'Episodios de atención',
    'Loading coordination workspace...': 'Cargando espacio de coordinación...',
    'Unable to load workspace.': 'No se pudo cargar el espacio de trabajo.',
    'Failed to load coordination workspace.': 'No se pudo cargar el espacio de coordinación.',
    'Failed to load care planning data.': 'No se pudieron cargar los datos de planificación asistencial.',
    'Unable to update episode.': 'No se pudo actualizar el episodio.',
    'Unable to save care plan.': 'No se pudo guardar el plan asistencial.',
    'Unable to update task.': 'No se pudo actualizar la tarea.',
    'Current password is invalid.': 'La contraseña actual no es válida.',
    'New password must be different from current password.': 'La nueva contraseña debe ser diferente de la contraseña actual.',
    'Unable to load assignees.': 'No se pudieron cargar los asignados.',
    'Task title is required.': 'El título de la tarea es obligatorio.',
    'Unable to create task.': 'No se pudo crear la tarea.',
    '{count} points': '{count} puntos',
    'Reason for visit or notes': 'Motivo de la visita o notas',
    'Upload photo': 'Subir foto',
    'Action failed': 'La acción falló',
    'The requested action could not be completed.': 'No se pudo completar la acción solicitada.',
    'Patient note created': 'Nota del paciente creada',
    'Patient note updated': 'Nota del paciente actualizada',
    'Patient note changes were saved.': 'Los cambios en la nota del paciente se guardaron.',
    'Patient document removed': 'Documento del paciente eliminado',
    'Patient document uploaded': 'Documento del paciente cargado',
    'Patient document changes were saved.': 'Los cambios en el documento del paciente se guardaron.',
    'Appointment updated': 'Cita actualizada',
    'Appointment changes were saved.': 'Los cambios en la cita se guardaron.',
    'Prescription updated': 'Receta actualizada',
    'Prescription changes were saved.': 'Los cambios en la receta se guardaron.',
    'Billing updated': 'Facturación actualizada',
    'Billing changes were saved.': 'Los cambios en facturación se guardaron.',
    'Telemedicine updated': 'Telemedicina actualizada',
    'Telemedicine changes were saved.': 'Los cambios en telemedicina se guardaron.',
    'Patient record updated': 'Registro del paciente actualizado',
    'Patient record changes were saved.': 'Los cambios en el registro del paciente se guardaron.',
    'System activity captured': 'Actividad del sistema registrada',
    'Changes were saved successfully.': 'Los cambios se guardaron correctamente.',
    on: 'el',
  },
  it: {
    'Loading...': 'Caricamento...',
    'Redirecting to login...': 'Reindirizzamento al login...',
    'Auth error': 'Errore di autenticazione',
    'Loading patient...': 'Caricamento paziente...',
    'Patient not found': 'Paziente non trovato',
    'Back to patients': 'Torna ai pazienti',
    'Patient Details': 'Dettagli paziente',
    'Back to list': 'Torna all elenco',
    Edit: 'Modifica',
    Save: 'Salva',
    'Saving...': 'Salvataggio...',
    Cancel: 'Annulla',
    Close: 'Chiudi',
    'Choose the audit depth, what AI workflows are monitored, and which safeguards stay active.':
      'Scegli la profondità di audit, quali flussi IA vengono monitorati e quali salvaguardie rimangono attive.',
    'Save Settings': 'Salva impostazioni',
    'AI governance settings saved.': 'Impostazioni di governance IA salvate.',
    'Failed to load AI governance settings.': 'Impossibile caricare le impostazioni di governance IA.',
    'Failed to save AI governance settings.': 'Impossibile salvare le impostazioni di governance IA.',
    'Audit Policy': 'Policy di audit',
    'Control how aggressively Elen1 captures, samples, and governs AI activity.':
      'Controlla con quale livello di rigore Elen1 acquisisce, campiona e governa l’attività IA.',
    'Audit level': 'Livello di audit',
    Minimal: 'Minimo',
    Standard: 'Standard',
    Strict: 'Rigoroso',
    'Capture request summaries': 'Acquisisci riepiloghi delle richieste',
    'Capture response summaries': 'Acquisisci riepiloghi delle risposte',
    'Capture explanation details': 'Acquisisci dettagli esplicativi',
    'Require approval for high-risk actions': 'Richiedi approvazione per azioni ad alto rischio',
    'Require review for medium-risk actions': 'Richiedi revisione per azioni a rischio medio',
    'Enable QA sampling': 'Abilita campionamento QA',
    'Monitored Actions': 'Azioni monitorate',
    'Decide exactly which AI workflows are monitored and which ones require a durable audit trail.':
      'Decidi esattamente quali flussi IA vengono monitorati e quali richiedono una traccia di audit persistente.',
    Workflow: 'Flusso',
    Monitor: 'Monitora',
    Audit: 'Audit',
    'No AI workflows are registered yet.': 'Nessun flusso IA registrato ancora.',
    Overview: 'Panoramica',
    Prescription: 'Prescrizione',
    Prescriptions: 'Prescrizioni',
    Documents: 'Documenti',
    Medications: 'Farmaci',
    Vaccinations: 'Vaccinazioni',
    Clinical: 'Clinico',
    Notes: 'Note',
    'Medical Forms': 'Moduli medici',
    Forms: 'Moduli',
    'Search medical forms': 'Cerca moduli medici',
    'No forms attached to this appointment yet.': 'Nessun modulo ancora collegato a questo appuntamento.',
    'Saving will send any newly added forms to the patient and create entries in Patient Medical Forms.':
      'Salvando, tutti i nuovi moduli aggiunti verranno inviati al paziente e verranno create voci in Moduli medici del paziente.',
    'Treatment Plans': 'Piani terapeutici',
    Monitoring: 'Monitoraggio',
    'Portal Access': 'Accesso al portale',
    Invoices: 'Fatture',
    Visits: 'Visite',
    Billing: 'Fatturazione',
    Telemedicine: 'Telemedicina',
    Allergies: 'Allergie',
    Problems: 'Problemi',
    'None listed': 'Nessuno',
    Provider: 'Medico',
    'No visits yet': 'Nessuna visita ancora',
    'Search patient name or MRN': 'Cerca nome paziente o MRN',
    'No patients found': 'Nessun paziente trovato',
    'Loading patients...': 'Caricamento pazienti...',
    'Loading patient details...': 'Caricamento dettagli paziente...',
    'Loading portal access...': 'Caricamento accesso al portale...',
    'Select a patient to begin prescribing.': 'Seleziona un paziente per iniziare a prescrivere.',
    'Select a patient to start billing.': 'Seleziona un paziente per iniziare la fatturazione.',
    'Manual Tests': 'Test manuali',
    'Add allergy': 'Aggiungi allergia',
    'Add problem': 'Aggiungi problema',
    'Add medication': 'Aggiungi farmaco',
    with: 'con',
    'No upcoming visits': 'Nessuna visita imminente',
    Timeline: 'Timeline',
    'No appointment history yet.': 'Nessuna cronologia appuntamenti disponibile.',
    'Portal access active': 'Accesso al portale attivo',
    'Portal access not active': 'Accesso al portale non attivo',
    'Patient portal identity': 'Identita del portale paziente',
    'Portal email': 'Email del portale',
    'Portal language': 'Lingua del portale',
    'Password state': 'Stato password',
    Ready: 'Pronto',
    Linked: 'Collegato',
    'Request failed': 'Richiesta non riuscita',
    'Activate portal access': 'Attiva accesso al portale',
    'Send new credentials': 'Invia nuove credenziali',
    'Open portal login': 'Apri accesso portale',
    'Linked portal user': 'Utente portale collegato',
    'Access timeline': 'Cronologia accesso',
    'Last password change': 'Ultimo cambio password',
    'Last account update': 'Ultimo aggiornamento account',
    'Password reset required': 'Reset password richiesto',
    'Cognito provisioning pending': 'Provisioning Cognito in attesa',
    Provisioned: 'Provisionato',
    'Not provisioned': 'Non provisionato',
    'Active user': 'Utente attivo',
    'Inactive user': 'Utente inattivo',
    'Credentials sent': 'Credenziali inviate',
    'Create the patient portal account, provision the Cognito identity, and send a temporary password.':
      'Crea l account del portale paziente, provisiona l identita Cognito e invia una password temporanea.',
    'Send a new temporary password to the linked patient portal account.':
      'Invia una nuova password temporanea all account del portale paziente gia collegato.',
    'The portal email is locked after activation to avoid desynchronizing the linked Cognito identity.':
      'L email del portale viene bloccata dopo l attivazione per evitare di desincronizzare l identita Cognito collegata.',
    'Portal access was activated, but email delivery is currently in mock mode.':
      'L accesso al portale e stato attivato, ma l invio email e attualmente in modalita mock.',
    'Portal credentials were sent successfully.': 'Le credenziali del portale sono state inviate correttamente.',
    'New portal credentials were sent successfully.': 'Le nuove credenziali del portale sono state inviate correttamente.',
    'A temporary password was generated, but email delivery is currently in mock mode.':
      'E stata generata una password temporanea, ma l invio email e attualmente in modalita mock.',
    'Failed to load portal access': 'Impossibile caricare l accesso al portale',
    'Failed to activate portal access': 'Impossibile attivare l accesso al portale',
    'Failed to send portal credentials': 'Impossibile inviare le credenziali del portale',
    'Patient portal routes are disabled in this environment. Activation can be prepared, but portal sign-in will remain unavailable until the portal is enabled.':
      'Le rotte del portale paziente sono disabilitate in questo ambiente. L attivazione puo essere preparata, ma l accesso al portale restera non disponibile finche il portale non viene abilitato.',
    'Cognito user provisioning is disabled. Enable it before activating portal access.':
      'Il provisioning utenti Cognito e disabilitato. Abilitalo prima di attivare l accesso al portale.',
    'Visits trend': 'Trend visite',
    Upcoming: 'Prossime',
    Date: 'Data',
    'Title / Type': 'Titolo / Tipo',
    Duration: 'Durata',
    'No appointments recorded.': 'Nessun appuntamento registrato.',
    Televisits: 'Televisite',
    'New Televisit': 'Nuova televisita',
    Televisit: 'Televisita',
    'No telemedicine appointments recorded.': 'Nessun appuntamento di telemedicina registrato.',
    'Edit patient': 'Modifica paziente',
    'City / Location': 'Citta / Localita',
    State: 'Stato',
    'Postal code': 'CAP',
    'Insurance provider': 'Assicurazione',
    'Insurance member ID': 'ID membro assicurazione',
    'Insurance group #': 'Gruppo assicurazione #',
    'Emergency contact name': 'Nome contatto di emergenza',
    'Emergency contact phone': 'Telefono contatto di emergenza',
    'Quick add': 'Aggiunta rapida',
    'Search medication to add': 'Cerca farmaco da aggiungere',
    'New allergy': 'Nuova allergia',
    'New problem': 'Nuovo problema',
    'New medication': 'Nuovo farmaco',
    'Failed to save': 'Salvataggio non riuscito',
    'Edit event': 'Modifica evento',
    Add: 'Aggiungi',
    Select: 'Seleziona',
    'Patient Treatment Planning Workspace': 'Area di pianificazione terapeutica del paziente',
    'Assign a settings-defined plan template and manage goals, interventions, medication, monitoring, and outcomes.':
      'Assegna un modello di piano definito nelle impostazioni e gestisci obiettivi, interventi, farmaci, monitoraggio ed esiti.',
    'Add treatment plan': 'Aggiungi piano terapeutico',
    'Assigned Plans': 'Piani assegnati',
    'No treatment plans assigned yet.': 'Nessun piano terapeutico ancora assegnato.',
    'Select a treatment plan to edit.': 'Seleziona un piano terapeutico da modificare.',
    'Failed to load treatment plans.': 'Impossibile caricare i piani terapeutici.',
    'Select a treatment plan template.': 'Seleziona un modello di piano terapeutico.',
    'Treatment plan assigned.': 'Piano terapeutico assegnato.',
    'Unable to create treatment plan.': 'Impossibile creare il piano terapeutico.',
    'Treatment plan saved.': 'Piano terapeutico salvato.',
    'Unable to save treatment plan.': 'Impossibile salvare il piano terapeutico.',
    'Plan review logged.': 'Revisione del piano registrata.',
    'Unable to mark review.': 'Impossibile contrassegnare la revisione.',
    'Delete treatment plan?': 'Eliminare il piano terapeutico?',
    'Treatment plan deleted.': 'Piano terapeutico eliminato.',
    'Unable to delete treatment plan.': 'Impossibile eliminare il piano terapeutico.',
    'Loading treatment plans...': 'Caricamento piani terapeutici...',
    'Mark Reviewed': 'Segna come revisionato',
    'Next review': 'Prossima revisione',
    'Assign Treatment Plan': 'Assegna piano terapeutico',
    'Assign Plan': 'Assegna piano',
    inactive: 'inattivo',
    'Diagnosis (optional)': 'Diagnosi (opzionale)',
    Title: 'Titolo',
    Priority: 'Priorita',
    'Review Cadence (days)': 'Cadenza revisione (giorni)',
    'Progress %': 'Avanzamento %',
    'Adherence %': 'Aderenza %',
    'Start Date': 'Data inizio',
    'Target End Date': 'Data fine obiettivo',
    'Next Review': 'Prossima revisione',
    'Patient Instructions': 'Istruzioni per il paziente',
    'Clinician Notes': 'Note del clinico',
    'Barriers (comma separated)': 'Barriere (separate da virgola)',
    'Outcomes (comma separated)': 'Esiti (separati da virgola)',
    Goals: 'Obiettivi',
    Target: 'Target',
    'Timeframe (days)': 'Tempistica (giorni)',
    Interventions: 'Interventi',
    Type: 'Tipo',
    Frequency: 'Frequenza',
    'Duration (days)': 'Durata (giorni)',
    'Owner Role': 'Ruolo responsabile',
    Instructions: 'Istruzioni',
    Medication: 'Farmaco',
    Dose: 'Dose',
    Route: 'Via',
    Indication: 'Indicazione',
    'Target Range': 'Intervallo obiettivo',
    'Alert Threshold': 'Soglia di allerta',
    'Action If Out Of Range': 'Azione se fuori intervallo',
    'Follow-Up': 'Follow-up',
    Modality: 'Modalita',
    'Interval (days)': 'Intervallo (giorni)',
    Purpose: 'Scopo',
    Education: 'Educazione',
    Topic: 'Argomento',
    Objective: 'Obiettivo',
    Materials: 'Materiali',
    Required: 'Obbligatorio',
    'Escalation Rules': 'Regole di escalation',
    Trigger: 'Trigger',
    Severity: 'Gravita',
    'Care Team': 'Team di cura',
    'Member Name': 'Nome membro',
    Responsibility: 'Responsabilita',
    'Remove row': 'Rimuovi riga',
    'Failed to load manual tests.': 'Impossibile caricare i test manuali.',
    'Image uploaded.': 'Immagine caricata.',
    'Image upload failed.': 'Caricamento immagine non riuscito.',
    'Upload an image before running AI analysis.': 'Carica un immagine prima di avviare l analisi AI.',
    'AI analyzed image': 'Immagine analizzata da AI',
    confidence: 'confidenza',
    'confidence not provided': 'confidenza non fornita',
    'AI analysis applied.': 'Analisi AI applicata.',
    'AI analysis failed.': 'Analisi AI non riuscita.',
    'Select a test type before saving.': 'Seleziona un tipo di test prima di salvare.',
    'Manual test entry saved.': 'Voce test manuale salvata.',
    'Failed to save manual test entry.': 'Impossibile salvare la voce test manuale.',
    'Delete this manual test entry?': 'Eliminare questa voce test manuale?',
    'Entry deleted.': 'Voce eliminata.',
    'Failed to delete entry.': 'Impossibile eliminare la voce.',
    'Unable to open image.': 'Impossibile aprire l immagine.',
    'Loading manual tests...': 'Caricamento test manuali...',
    'Image and strip-based patient tests': 'Test paziente basati su immagini e strip',
    'Definitions come from Settings. Upload test images and optionally let AI classify the result.':
      'Le definizioni arrivano da Impostazioni. Carica immagini test e opzionalmente lascia che l AI classifichi il risultato.',
    'Add Manual Test': 'Aggiungi test manuale',
    'Recorded Manual Tests': 'Test manuali registrati',
    Test: 'Test',
    'No manual tests recorded yet.': 'Nessun test manuale registrato.',
    'Add Manual Test Entry': 'Aggiungi voce test manuale',
    'Analyzing...': 'Analisi in corso...',
    'AI Analyze Image': 'Analizza immagine con AI',
    'Test Type': 'Tipo test',
    'Select test': 'Seleziona test',
    'Measured At': 'Misurato il',
    'Value (text)': 'Valore (testo)',
    'Trace / Moderate / etc': 'Traccia / Moderato / ecc',
    'Value (number)': 'Valore (numero)',
    Unit: 'Unita',
    Category: 'Categoria',
    'Uploading...': 'Caricamento...',
    'Upload Image': 'Carica immagine',
    'No image': 'Nessuna immagine',
    'Save Entry': 'Salva voce',
    'Core Clinical': 'Core clinico',
    Financial: 'Finanziario',
    'Telemed + Remote Care': 'Telemedicina + assistenza remota',
    'Clinic Admin': 'Amministrazione clinica',
    'Walk-ins': 'Accessi diretti',
    'Rapid triage, quick intake, and fast visit routing.': 'Triage rapido, intake veloce e instradamento rapido delle visite.',
    'Lab/Imaging': 'Laboratorio/Imaging',
    'Real-time results triage board with quick actions.': 'Bacheca triage risultati in tempo reale con azioni rapide.',
    'Genomic Data Integration': 'Integrazione dati genomici',
    'Link variants with phenotype and treatment paths.': 'Collega varianti con fenotipo e percorsi terapeutici.',
    'Universal Search': 'Ricerca universale',
    'Search patients, labs, meds, invoices in one box.': 'Cerca pazienti, laboratori, farmaci e fatture in un unico campo.',
    'Room Management': 'Gestione stanze',
    'Assign rooms, track occupancy, and cleaning state.': 'Assegna stanze, monitora occupazione e stato pulizia.',
    'Claims Retry Engine': 'Motore di retry dei claim',
    'Auto-detect denials and smart resubmits.': 'Rileva automaticamente i dinieghi e reinvii intelligenti.',
    'Billing Rules Engine': 'Motore regole di fatturazione',
    'Payer/procedure-specific rules and guardrails.': 'Regole e vincoli specifici per pagatore/procedura.',
    'Subscription / Membership': 'Abbonamento / Membership',
    'Recurring plans, auto-charges, benefits tracking.': 'Piani ricorrenti, addebiti automatici e tracciamento benefici.',
    'Revenue Insights Dashboard': 'Dashboard insight ricavi',
    'Collections, AR aging, payer mix at a glance.': 'Incassi, aging crediti e mix pagatori a colpo d occhio.',
    'Asynchronous Visits': 'Visite asincrone',
    'Store-and-forward uploads with clinician responses.': 'Upload store-and-forward con risposte del clinico.',
    'Failed to refresh feed': 'Impossibile aggiornare il feed',
    'Failed to create enrollment': 'Impossibile creare l iscrizione',
    'Failed to simulate incoming data': 'Impossibile simulare i dati in ingresso',
    'Metric value must be a number.': 'Il valore della metrica deve essere un numero.',
    'Failed to ingest reading': 'Impossibile acquisire la lettura',
    'active device program(s)': 'programma/i dispositivo attivo/i',
    'Last data': 'Ultimi dati',
    'No readings yet': 'Nessuna lettura ancora',
    'Live polling': 'Polling live',
    'Risk score': 'Punteggio di rischio',
    Alerts: 'Avvisi',
    'Active red-flag prompts': 'Prompt di allarme attivi',
    'Device programs': 'Programmi dispositivo',
    'Patient enrollments': 'Iscrizioni paziente',
    'Incoming readings': 'Letture in ingresso',
    'Last 14 days in this feed': 'Ultimi 14 giorni in questo feed',
    'Trend Signals': 'Segnali di tendenza',
    'No metric history yet. Ingest or simulate readings to render trend lines.':
      'Nessuna cronologia metriche ancora. Acquisisci o simula letture per mostrare le linee di tendenza.',
    'Device Enrollment': 'Iscrizione dispositivo',
    'Enroll Device': 'Iscrivi dispositivo',
    'Patient Enrollments': 'Iscrizioni paziente',
    'real data only': 'solo dati reali',
    'No device enrolled yet.': 'Nessun dispositivo ancora iscritto.',
    'Simulate packet': 'Simula pacchetto',
    'Manual Reading Ingest': 'Acquisizione lettura manuale',
    'Add Reading': 'Aggiungi lettura',
    'Recent incoming updates': 'Aggiornamenti recenti in ingresso',
    Metric: 'Metrica',
    Value: 'Valore',
    'No readings yet.': 'Nessuna lettura ancora.',
    'Device profile': 'Profilo dispositivo',
    'Select profile': 'Seleziona profilo',
    'External Patient ID': 'ID paziente esterno',
    'External Device ID': 'ID dispositivo esterno',
    'Pairing Code': 'Codice di associazione',
    'Ingest Manual Reading': 'Acquisisci lettura manuale',
    Enrollment: 'Iscrizione',
    'Metric Key': 'Chiave metrica',
    'Metric Label': 'Etichetta metrica',
    'Ingest Reading': 'Acquisisci lettura',
    'Patient Notes Workspace': 'Area note paziente',
    'Rich note editor with live autocomplete and structured AI clinical completion.':
      'Editor note avanzato con completamento automatico live e completamento clinico AI strutturato.',
    'New Note': 'Nuova nota',
    'Autocomplete On': 'Autocompletamento attivo',
    'Autocomplete Off': 'Autocompletamento disattivato',
    'Live AI Suggestion On': 'Suggerimenti AI live attivi',
    'Live AI Suggestion Off': 'Suggerimenti AI live disattivi',
    'Additional Questions': 'Domande aggiuntive',
    'Next Documentation Line': 'Prossima riga di documentazione',
    'Prescription draft saved successfully.': 'Bozza prescrizione salvata con successo.',
    'Prescription sent successfully.': 'Prescrizione inviata con successo.',
    'Search notes...': 'Cerca note...',
    'Pinned only': 'Solo fissate',
    'No notes found for this patient.': 'Nessuna nota trovata per questo paziente.',
    'Note title': 'Titolo nota',
    Bold: 'Grassetto',
    Italic: 'Corsivo',
    Underline: 'Sottolineato',
    'Bullet List': 'Elenco puntato',
    'Numbered List': 'Elenco numerato',
    'Insert Image': 'Inserisci immagine',
    'Enter URL': 'Inserisci URL',
    'Insert Link': 'Inserisci link',
    Clear: 'Cancella',
    'SOAP Template': 'Modello SOAP',
    'Pin note': 'Fissa nota',
    'Live AI suggestion': 'Suggerimento AI live',
    'Thinking...': 'Elaborazione...',
    'Tip: press Tab to accept': 'Suggerimento: premi Tab per accettare',
    Accept: 'Accetta',
    Dismiss: 'Ignora',
    'No suggestion yet. Add a few symptoms or findings.': 'Nessun suggerimento ancora. Aggiungi alcuni sintomi o reperti.',
    Author: 'Autore',
    Created: 'Creata',
    'Last updated': 'Ultimo aggiornamento',
    'Current user': 'Utente corrente',
    'Unable to load notes.': 'Impossibile caricare le note.',
    'You have unsaved note changes. Continue without saving?': 'Hai modifiche non salvate nella nota. Continuare senza salvare?',
    'Image is too large. Maximum size is 3 MB per image.': 'L immagine e troppo grande. La dimensione massima e 3 MB per immagine.',
    'Failed to read image file.': 'Impossibile leggere il file immagine.',
    'Image inserted into note.': 'Immagine inserita nella nota.',
    'Live AI suggestion is currently unavailable.': 'Il suggerimento AI live non e disponibile al momento.',
    'Add some note content before running AI Auto Complete.': 'Aggiungi contenuto alla nota prima di eseguire AI Auto Complete.',
    'AI Auto Complete': 'AI Auto Complete',
    'AI Clinical Summary': 'Riepilogo clinico AI',
    'Proposed Diagnoses': 'Diagnosi proposte',
    'AI analysis inserted. Please review and edit before signing.': 'Analisi AI inserita. Rivedi e modifica prima della firma.',
    'AI Auto Complete failed.': 'AI Auto Complete non riuscito.',
    'Note content cannot be empty.': 'Il contenuto della nota non puo essere vuoto.',
    'Note created.': 'Nota creata.',
    'Note updated.': 'Nota aggiornata.',
    'Failed to save note.': 'Impossibile salvare la nota.',
    'Delete this note? This action can be audited and hidden from active views.': 'Eliminare questa nota? Questa azione puo essere registrata e nascosta dalle viste attive.',
    'Note deleted.': 'Nota eliminata.',
    'Failed to delete note.': 'Impossibile eliminare la nota.',
    'Replace current note content with SOAP template?': 'Sostituire il contenuto corrente della nota con il modello SOAP?',
    'No content preview': 'Nessuna anteprima contenuto',
    'AI Call Summaries': 'Riepiloghi chiamate AI',
    'Summaries → structured notes → billing suggestions.': 'Riepiloghi -> note strutturate -> suggerimenti di fatturazione.',
    'Summaries -> structured notes -> billing suggestions.': 'Riepiloghi -> note strutturate -> suggerimenti di fatturazione.',
    'Virtual Waiting Room': "Sala d'attesa",
    'Recent telemedicine visits, patient intake, and instant room launch in one workspace.':
      'Visite recenti di telemedicina, intake del paziente e avvio immediato della stanza in un unico spazio di lavoro.',
    'Pre-call ID check and queue visibility.': 'Verifica identita pre-chiamata e visibilita coda.',
    'Inventory + Auto-Reorder': 'Inventario + riordino automatico',
    'Stock levels, expiries, vendor reorders.': 'Livelli stock, scadenze e riordini fornitori.',
    'Pharmacy Dispensing': 'Dispensazione farmacia',
    'Dispense tracking, labels, lot/expiration.': 'Tracciamento dispensazione, etichette, lotto/scadenza.',
    'Reports Builder': 'Builder report',
    'Custom dashboards and exports.': 'Dashboard personalizzate ed esportazioni.',
    'Telemed Room': 'Stanza telemedicina',
    'Cancel Telemed': 'Annulla telemedicina',
    "Today's Telemed Visits": 'Visite telemedicina di oggi',
    'Join or copy links directly.': 'Entra o copia i link direttamente.',
    Refresh: 'Aggiorna',
    'Search patient, provider, type...': 'Cerca paziente, medico, tipo...',
    'All statuses': 'Tutti gli stati',
    Waiting: 'In attesa',
    'In session': 'In sessione',
    Finished: 'Terminato',
    Patient: 'Paziente',
    Open: 'Apri',
    Time: 'Orario',
    'Visit type': 'Tipo di visita',
    Status: 'Stato',
    Actions: 'Azioni',
    Join: 'Entra',
    Link: 'Link',
    Email: 'Email',
    'Loading telemed visits.': 'Caricamento visite telemedicina.',
    'No telemed visits found.': 'Nessuna visita telemedicina trovata.',
    'Join as provider (host)': 'Entra come medico (host)',
    'Copy patient link': 'Copia link paziente',
    'Send email invite': 'Invia invito email',
    'Join Guidance': 'Guida accesso',
    'Use host token for providers; guest token for patients.':
      'Usa token host per i medici e token ospite per i pazienti.',
    'Provider (host)': 'Medico (host)',
    Guest: 'Ospite',
    'Start Live Transcription': 'Avvia trascrizione live',
    'Stop Live Transcription': 'Ferma trascrizione live',
    'No transcript yet': 'Nessuna trascrizione ancora',
    'Preparing call...': 'Preparazione chiamata...',
    'Live AI Diagnostics': 'Diagnostica AI live',
    'Run diagnostics now': 'Esegui diagnostica ora',
    'Auto diagnostics': 'Diagnostica automatica',
    'Clinical Notes': 'Note cliniche',
    'Type live clinical observations, exam findings, and plan...':
      'Scrivi osservazioni cliniche live, reperti obiettivi e piano...',
    'Saving notes...': 'Salvataggio note...',
    Saved: 'Salvato',
    'Speech recognition is not supported in this browser. Use Chrome or Edge.':
      'Il riconoscimento vocale non e supportato in questo browser. Usa Chrome o Edge.',
    'Transcription error occurred.': 'Si e verificato un errore di trascrizione.',
    'Unable to start transcription.': 'Impossibile avviare la trascrizione.',
    'Unable to update transcript segment.': 'Impossibile aggiornare il segmento di trascrizione.',
    'Failed to create telemed session': 'Impossibile creare la sessione di telemedicina',
    'Failed to join call': 'Impossibile entrare nella chiamata',
    'Failed to sync transcript chunk.': 'Impossibile sincronizzare il blocco di trascrizione.',
    'Failed to run live diagnostics.': 'Impossibile eseguire la diagnostica live.',
    'Failed to save clinical notes.': 'Impossibile salvare le note cliniche.',
    'Failed to end telemedicine visit.': 'Impossibile terminare la visita di telemedicina.',
    'Visit ended. Telemedicine summary was added to the patient notes.':
      'Visita terminata. Il riepilogo telemedicina e stato aggiunto alle note del paziente.',
    'Unknown sex': 'Sesso sconosciuto',
    'AI Summary': 'Riepilogo AI',
    'Longitudinal Clinical Snapshot': 'Quadro clinico longitudinale',
    cached: 'in cache',
    'Rebuild summary now': 'Rigenera riepilogo ora',
    'Building chart summary...': 'Generazione riepilogo cartella...',
    Refreshing: 'Aggiornamento',
    Highlights: 'Punti chiave',
    'Risk Flags': 'Rischi',
    'Care Gaps': 'Lacune assistenziali',
    'No summary available yet.': 'Nessun riepilogo disponibile al momento.',
    'No join link available to email.': 'Nessun link disponibile da inviare via email.',
    'Failed to send email': 'Invio email non riuscito',
    'Failed to load telemed visits': 'Impossibile caricare le visite telemedicina',
    'Unable to generate patient AI summary.': 'Impossibile generare il riepilogo AI del paziente.',
    'None flagged': 'Nessun elemento segnalato',
    'Failed to load patient': 'Impossibile caricare il paziente',
    Back: 'Indietro',
    Role: 'Ruolo',
    'Clinical Visit Room': 'Stanza visita clinica',
    'Telemed room for selected patient below.': 'Stanza telemedicina per il paziente selezionato qui sotto.',
    'Instant meeting': 'Riunione istantanea',
    'Launch Virtual Room': 'Avvia stanza virtuale',
    'Create a telemedicine appointment instantly and open the provider room.':
      'Crea subito un appuntamento di telemedicina e apri la stanza del medico.',
    'Start instant meeting': 'Avvia riunione istantanea',
    'Auto-selected from your current schedule': 'Selezionato automaticamente dalla tua agenda attuale',
    'No telemedicine appointment type configured': 'Nessun tipo di appuntamento telemedicina configurato',
    'Uses the configured default duration': 'Usa la durata predefinita configurata',
    'Start telemed': 'Avvia telemedicina',
    'Search for an existing patient to start this telemedicine meeting.':
      'Cerca un paziente esistente per avviare questa riunione di telemedicina.',
    'Search by name, MRN, or phone...': 'Cerca per nome, MRN o telefono...',
    'Select a patient to start an instant meeting.': 'Seleziona un paziente per avviare una riunione istantanea.',
    'No provider available for this instant meeting.': 'Nessun medico disponibile per questa riunione istantanea.',
    'No telemedicine appointment type is configured.': 'Nessun tipo di appuntamento telemedicina configurato.',
    'AI Clinical Analysis': 'Analisi clinica AI',
    'End Visit & Save Summary': 'Termina visita e salva riepilogo',
    'Connecting to Daily...': 'Connessione a Daily...',
    'Patient Briefing': 'Briefing paziente',
    'Patient context unavailable.': 'Contesto paziente non disponibile.',
    'Live Transcription': 'Trascrizione live',
    'Final transcript chunks are editable for 2 minutes.': 'I blocchi finali della trascrizione sono modificabili per 2 minuti.',
    Updated: 'Aggiornato',
    'Start live transcription to capture the consultation.': 'Avvia la trascrizione live per catturare il consulto.',
    'Auto-saved and included in AI diagnostics.': 'Salvato automaticamente e incluso nella diagnostica AI.',
    'Save failed': 'Salvataggio non riuscito',
    Idle: 'In attesa',
    'Live Diagnostics': 'Diagnostica live',
    'AI analysis from transcript + notes.': 'Analisi AI da trascrizione + note.',
    'Auto-run': 'Esecuzione automatica',
    'Running clinical analysis...': 'Analisi clinica in esecuzione...',
    'No diagnostics yet. Add transcript/notes then run analysis.':
      'Nessuna diagnostica ancora. Aggiungi trascrizione/note e avvia l analisi.',
    Summary: 'Riepilogo',
    Confidence: 'Confidenza',
    'Red Flags': 'Segnali di allarme',
    Action: 'Azione',
    Differential: 'Diagnosi differenziale',
    'Missing Questions': 'Domande mancanti',
    'Suggested Next Steps': 'Prossimi passi suggeriti',
    minutes: 'minuti',
    Male: 'Maschio',
    Female: 'Femmina',
    Other: 'Altro',
    Clinician: 'Clinico',
    Unspecified: 'Non specificato',
    'Failed to load patient briefing card.': 'Impossibile caricare la scheda briefing paziente.',
    'Failed to load live telemedicine state.': 'Impossibile caricare lo stato telemedicina live.',
    'Transcription error': 'Errore di trascrizione',
    '1) Use the join link & host token from the appointment to start the call.':
      '1) Usa il link di accesso e il token host dell appuntamento per avviare la chiamata.',
    '2) Patients join with guest token or plain link if allowed.':
      '2) I pazienti entrano con token ospite o link diretto se consentito.',
    '3) End visit in the appointment to invalidate tokens.':
      '3) Termina la visita nell appuntamento per invalidare i token.',
    'N/A': 'N/D',
    'Reports Dashboard': 'Dashboard dei report',
    'Reports and analytics coming soon.': 'Report e analisi in arrivo.',
    Generated: 'Generato',
    Next: 'Prossima',
    'Last visit': 'Ultima visita',
    DOB: 'Data nascita',
    yrs: 'anni',
    'High risk': 'Alto rischio',
    Appointments: 'Appuntamenti',
    'Schedule Board': 'Bacheca agenda',
    Prev: 'Precedente',
    'New Appointment': 'Nuovo appuntamento',
    Providers: 'Medici',
    'No providers': 'Nessun medico',
    'Loading appointments...': 'Caricamento appuntamenti...',
    Preview: 'Anteprima',
    Download: 'Scarica',
    Delete: 'Elimina',
    'Day view': 'Vista giornaliera',
    'Week view': 'Vista settimanale',
    day: 'giorno',
    week: 'settimana',
    month: 'mese',
    appt: 'app.',
    Appointment: 'Appuntamento',
    Scheduled: 'Programmato',
    'Checked-in': 'Check-in',
    Completed: 'Completato',
    Cancelled: 'Annullato',
    'No-show': 'Assente',
    'Failed to load appointments': 'Impossibile caricare gli appuntamenti',
    'Failed to load patients': 'Impossibile caricare i pazienti',
    'Failed to update appointment': 'Impossibile aggiornare l appuntamento',
    'Failed to save appointment': 'Impossibile salvare l appuntamento',
    'Patient Immunization Record': 'Registro immunizzazioni del paziente',
    'Capture administered/scheduled/refused vaccines with full traceability (lot, manufacturer, VIS, and next due date).':
      'Registra vaccini somministrati, programmati o rifiutati con tracciabilita completa (lotto, produttore, VIS e prossima data).',
    'Vaccination History': 'Storico vaccinazioni',
    'Next Due': 'Prossima dose',
    'Search vaccine, disease, lot...': 'Cerca vaccino, malattia, lotto...',
    'Loading vaccinations...': 'Caricamento vaccinazioni...',
    'Failed to load vaccination records.': 'Impossibile caricare i registri vaccinali.',
    'Vaccine name is required.': 'Il nome del vaccino e obbligatorio.',
    'Vaccination record updated.': 'Registro vaccinale aggiornato.',
    'Vaccination record added.': 'Registro vaccinale aggiunto.',
    'Failed to save vaccination record.': 'Impossibile salvare il registro vaccinale.',
    'Delete vaccination record?': 'Eliminare il registro vaccinale?',
    'Vaccination record deleted.': 'Registro vaccinale eliminato.',
    'Failed to delete vaccination record.': 'Impossibile eliminare il registro vaccinale.',
    Total: 'Totale',
    'Administered/Historical': 'Somministrate/Storiche',
    'Potentially Overdue': 'Potenzialmente scadute',
    'Add Vaccine': 'Aggiungi vaccino',
    Vaccine: 'Vaccino',
    'Lot / Manufacturer': 'Lotto / Produttore',
    'No vaccination records found.': 'Nessun registro vaccinale trovato.',
    'Vaccination Form': 'Modulo vaccinazione',
    'Edit Vaccination Record': 'Modifica registro vaccinale',
    'Add Vaccination Record': 'Aggiungi registro vaccinale',
    'Vaccine Catalog': 'Catalogo vaccini',
    'Select from catalog (optional)...': 'Seleziona dal catalogo (opzionale)...',
    'Vaccine Name': 'Nome vaccino',
    'CVX Code': 'Codice CVX',
    Disease: 'Malattia',
    'Administration Date': 'Data somministrazione',
    'Recorded Date': 'Data registrazione',
    'Dose Number': 'Numero dose',
    'Series Doses': 'Dosi della serie',
    'Body Side': 'Lato del corpo',
    'Dose Volume': 'Volume dose',
    'Dose Unit': 'Unita dose',
    Expiration: 'Scadenza',
    Manufacturer: 'Produttore',
    'Administered By': 'Somministrato da',
    Location: 'Luogo',
    'Funding Source': 'Fonte di finanziamento',
    'VIS Date': 'Data VIS',
    'VIS Edition Date': 'Data edizione VIS',
    'Next Due Date': 'Prossima data',
    Source: 'Fonte',
    'External ID': 'ID esterno',
    'Booster dose': 'Dose di richiamo',
    'Update Record': 'Aggiorna registro',
    'Unable to load patient documents.': 'Impossibile caricare i documenti del paziente.',
    'Failed to open document preview.': 'Impossibile aprire l anteprima del documento.',
    'Unable to fetch document download URL.': 'Impossibile ottenere l URL di download del documento.',
    'Document deleted.': 'Documento eliminato.',
    'Failed to delete document.': 'Impossibile eliminare il documento.',
    '1 document uploaded successfully.': '1 documento caricato con successo.',
    'documents uploaded successfully.': 'documenti caricati con successo.',
    'Document upload failed.': 'Caricamento documento non riuscito.',
    'Patient Document Viewer': 'Visualizzatore documenti paziente',
    'Upload files to S3, preview securely, and manage chart documents.': 'Carica file su S3, visualizzali in anteprima in modo sicuro e gestisci i documenti della cartella clinica.',
    'Upload Files': 'Carica file',
    'Stored Documents': 'Documenti archiviati',
    'Loading documents...': 'Caricamento documenti...',
    'Uploaded by': 'Caricato da',
    'No documents uploaded for this patient.': 'Nessun documento caricato per questo paziente.',
    'Give the document a clear title, choose its type, and complete any required metadata before uploading.':
      'Assegna al documento un titolo chiaro, scegli il tipo e completa i metadati obbligatori prima del caricamento.',
    'Select a file to upload': 'Seleziona un file da caricare',
    'Supported files include PDF, images, text, and common chart attachments.':
      'I file supportati includono PDF, immagini, testo e allegati comuni della cartella clinica.',
    'Example: Lab report, referral letter, or consent form': 'Esempio: referto di laboratorio, lettera di invio o modulo di consenso',
    'Select a document type': 'Seleziona un tipo di documento',
    'Optional note for clinicians reviewing this document.': 'Nota opzionale per i clinici che revisionano questo documento.',
    'patient-document': 'documento-paziente',
    'Patient Forms Workspace': 'Area moduli paziente',
    'Assign reusable forms, complete in clinic, or send secure links to patients before arrival.':
      'Assegna moduli riutilizzabili, compilali in clinica oppure invia link sicuri ai pazienti prima dell arrivo.',
    'No medical form instances for this patient yet.': 'Nessuna istanza di modulo medico ancora disponibile per questo paziente.',
    'Select a form instance to start filling.': 'Seleziona un istanza di modulo per iniziare la compilazione.',
    'Create Form': 'Crea modulo',
    'Unable to load patient forms.': 'Impossibile caricare i moduli del paziente.',
    'Unable to load selected form.': 'Impossibile caricare il modulo selezionato.',
    'Select a form template first.': 'Seleziona prima un modello di modulo.',
    'Form created and sent via': 'Modulo creato e inviato tramite',
    'Form instance created.': 'Istanza del modulo creata.',
    'Unable to create form instance.': 'Impossibile creare l istanza del modulo.',
    'Form marked complete.': 'Modulo contrassegnato come completato.',
    'Form saved.': 'Modulo salvato.',
    'Send form to email:': 'Invia modulo all email:',
    'Form sent': 'Modulo inviato',
    to: 'a',
    'Unable to send form.': 'Impossibile inviare il modulo.',
    total: 'totale',
    completed: 'completati',
    pending: 'in sospeso',
    'Loading forms...': 'Caricamento moduli...',
    Completion: 'Completamento',
    'Sent to': 'Inviato a',
    Due: 'Scadenza',
    'Create Form Instance': 'Crea istanza modulo',
    'Select template...': 'Seleziona modello...',
    'Patient email (optional)': 'Email paziente (opzionale)',
    'Send immediately by email': 'Invia subito via email',
    'Send Email': 'Invia email',
    Complete: 'Completa',
    'Telemed session creation failed': 'Impossibile creare la sessione di telemedicina',
    'Join session': 'Entra nella sessione',
    'Details of the appointment\'s patient': 'Dettagli del paziente dell appuntamento',
    'Change patient': 'Cambia paziente',
    'Select a Patient': 'Seleziona un paziente',
    'Search for an existing patient to schedule this appointment.':
      'Cerca un paziente esistente per programmare questo appuntamento.',
    'Appointment Details': 'Dettagli appuntamento',
    'Date, time, type, provider and status': 'Data, ora, tipo, medico e stato',
    'Date & Time': 'Data e ora',
    'Appointment Type': 'Tipo di appuntamento',
    'Appointment type': 'Tipo di appuntamento',
    'Select provider': 'Seleziona medico',
    'Duration (minutes)': 'Durata (minuti)',
    'Title / Reason': 'Titolo / Motivo',
    'Telemed Details': 'Dettagli telemedicina',
    'Link and details on your telemedicine session': 'Link e dettagli della tua sessione di telemedicina',
    'Before starting the telemedicine session, please ensure the patient understands that the consultation is being conducted remotely and may have limitations compared to an in-person exam.':
      'Prima di iniziare la sessione di telemedicina, assicurati che il paziente comprenda che la consulenza viene svolta da remoto e puo avere limiti rispetto a una visita in presenza.',
    'Join link will be created when you save this appointment.': 'Il link di accesso verra creato quando salvi questo appuntamento.',
    'Join call': 'Entra nella chiamata',
    'Generate join link on save': 'Genera link di accesso al salvataggio',
    'Edit Appointment': 'Modifica appuntamento',
    'Request Appointment': 'Richiedi appuntamento',
    min: 'min',
    PT: 'PT',
    'Drag blocks to reschedule • Hover for preview • Click empty space to create':
      'Trascina i blocchi per riprogrammare • Passa il cursore per anteprima • Clic su spazio vuoto per creare',
    'Drag between days to reschedule': 'Trascina tra i giorni per riprogrammare',
    All: 'Tutti',
    Telemed: 'Telemedicina',
    'Provider Day Dispatch': 'Smistamento giornaliero dei medici',
    'Resources & Staff': 'Risorse e staff',
    'Manage schedulable assets and non-clinical staff.': 'Gestisci risorse prenotabili e personale non clinico.',
    'Add Staff': 'Aggiungi staff',
    'Add Resource': 'Aggiungi risorsa',
    Staff: 'Staff',
    'Practice users (non-clinical)': 'Utenti dello studio (non clinici)',
    'Search staff...': 'Cerca staff...',
    Contact: 'Contatto',
    'No staff found.': 'Nessun membro dello staff trovato.',
    'Linked user': 'Utente collegato',
    'No linked user': 'Nessun utente collegato',
    'Edit staff': 'Modifica staff',
    'Delete staff': 'Elimina staff',
    Resources: 'Risorse',
    'Search resources...': 'Cerca risorse...',
    'No resources found.': 'Nessuna risorsa trovata.',
    Unassigned: 'Non assegnato',
    'Edit resource': 'Modifica risorsa',
    'Delete resource': 'Elimina risorsa',
    'Reservation tracking API available via /resources/reservations (create/read).': 'API di tracciamento prenotazioni disponibile tramite /resources/reservations (creazione/lettura).',
    'Failed to load data': 'Impossibile caricare i dati',
    'First name is required': 'Il nome è obbligatorio',
    'Last name is required': 'Il cognome è obbligatorio',
    'Role is required': 'Il ruolo è obbligatorio',
    'Name is required': 'Il nome è obbligatorio',
    'Type is required': 'Il tipo è obbligatorio',
    'Staff saved': 'Staff salvato',
    'Unable to save staff': 'Impossibile salvare lo staff',
    'Resource saved': 'Risorsa salvata',
    'Unable to save resource': 'Impossibile salvare la risorsa',
    'Delete this staff profile?': 'Eliminare questo profilo staff?',
    'Unable to delete staff': 'Impossibile eliminare lo staff',
    'Delete this resource?': 'Eliminare questa risorsa?',
    'Unable to delete resource': 'Impossibile eliminare la risorsa',
    Inactive: 'Inattivo',
    'Provider Directory': 'Directory medici',
    'Manage clinicians and link them to users.': 'Gestisci i clinici e collegali agli utenti.',
    'Add Provider': 'Aggiungi medico',
    'Search providers...': 'Cerca medici...',
    Specialties: 'Specialità',
    Languages: 'Lingue',
    'No providers found.': 'Nessun medico trovato.',
    'Failed to load providers': 'Impossibile caricare i medici',
    'Provider saved': 'Medico salvato',
    'Unable to save provider': 'Impossibile salvare il medico',
    'Delete this provider?': 'Eliminare questo medico?',
    'Unable to delete provider': 'Impossibile eliminare il medico',
    more: 'altri',
    None: 'Nessuno',
    'Roles & Permissions': 'Ruoli e permessi',
    'Define access levels and map permissions.': 'Definisci i livelli di accesso e mappa i permessi.',
    'Add Role': 'Aggiungi ruolo',
    Permissions: 'Permessi',
    'No roles found.': 'Nessun ruolo trovato.',
    'No permissions': 'Nessun permesso',
    'Failed to load roles': 'Impossibile caricare i ruoli',
    'Description is required': 'La descrizione è obbligatoria',
    'Role saved': 'Ruolo salvato',
    'Unable to save role': 'Impossibile salvare il ruolo',
    'Delete is not available for roles.': 'L eliminazione non è disponibile per i ruoli.',
    Error: 'Errore',
    'Scheduling Settings': 'Impostazioni pianificazione',
    'Control automation, calendar visibility, conflicts, and reminders.': 'Controlla automazione, visibilità del calendario, conflitti e promemoria.',
    'Saved successfully': 'Salvato con successo',
    'Profile updated.': 'Profilo aggiornato.',
    'Profile created.': 'Profilo creato.',
    'Failed to save profile': 'Impossibile salvare il profilo',
    'Profile deactivated.': 'Profilo disattivato.',
    'Failed to deactivate profile': 'Impossibile disattivare il profilo',
    'Update Profile': 'Aggiorna profilo',
    'Create Profile': 'Crea profilo',
    'Device Profiles': 'Profili dispositivo',
    'New Profile': 'Nuovo profilo',
    'Loading profiles...': 'Caricamento profili...',
    'Profile Editor': 'Editor profilo',
    'Telemedicine Settings': 'Impostazioni telemedicina',
    'Configure video visits and waiting rooms.': 'Configura videoconsulti e sale d attesa.',
    'Define reusable treatment-plan templates used in patient charts.': 'Definisci modelli riutilizzabili di piani terapeutici usati nelle cartelle paziente.',
    'Save Templates': 'Salva modelli',
    Templates: 'Modelli',
    New: 'Nuovo',
    'Loading templates...': 'Caricamento modelli...',
    'No templates configured yet.': 'Nessun modello configurato.',
    'Template Builder': 'Builder modello',
    Remove: 'Rimuovi',
    'Template staged locally.': 'Modello preparato localmente.',
    'Validation failed.': 'Validazione non riuscita.',
    'Treatment plan templates saved.': 'Modelli di piano terapeutico salvati.',
    'Failed to load templates.': 'Impossibile caricare i modelli.',
    'Failed to save templates.': 'Impossibile salvare i modelli.',
    'Save This Template Locally': 'Salva questo modello localmente',
    'Failed to load folders.': 'Impossibile caricare le cartelle.',
    'Failed to load threads.': 'Impossibile caricare le conversazioni.',
    'Failed to load conversation.': 'Impossibile caricare la conversazione.',
    'Attachment upload failed.': 'Caricamento allegato non riuscito.',
    Attachment: 'Allegato',
    'Failed to send message.': 'Impossibile inviare il messaggio.',
    'Attachment is unavailable.': 'L allegato non è disponibile.',
    'Failed to create thread.': 'Impossibile creare la conversazione.',
    'Failed to move thread.': 'Impossibile spostare la conversazione.',
    'Failed to add patient tag.': 'Impossibile aggiungere il tag paziente.',
    'Failed to remove patient tag.': 'Impossibile rimuovere il tag paziente.',
    'Failed to create folder.': 'Impossibile creare la cartella.',
    'Close compose': 'Chiudi composizione',
    Compose: 'Componi',
    'Loading folders...': 'Caricamento cartelle...',
    Folders: 'Cartelle',
    'Create folder': 'Crea cartella',
    'Search in folder': 'Cerca nella cartella',
    Inbox: 'Posta in arrivo',
    Archive: 'Archivio',
    'Waiting on Patient': 'In attesa del paziente',
    'Loading threads...': 'Caricamento conversazioni...',
    'No conversations in this folder.': 'Nessuna conversazione in questa cartella.',
    'Untitled conversation': 'Conversazione senza titolo',
    'No messages yet': 'Nessun messaggio ancora',
    Conversation: 'Conversazione',
    'Select a conversation': 'Seleziona una conversazione',
    'Conversation participant': 'Partecipante alla conversazione',
    'Loading conversation...': 'Caricamento conversazione...',
    'Select a thread to view messages.': 'Seleziona una conversazione per vedere i messaggi.',
    System: 'Sistema',
    Seen: 'Visto',
    'Write a message': 'Scrivi un messaggio',
    Tag: 'Tag',
    Emoji: 'Emoji',
    Attach: 'Allega',
    More: 'Altro',
    Sending: 'Invio',
    'Sending...': 'Invio...',
    Send: 'Invia',
    'New message': 'Nuovo messaggio',
    Recipients: 'Destinatari',
    'Search recipients': 'Cerca destinatari',
    Subject: 'Oggetto',
    'Patient tags': 'Tag paziente',
    'Search patients': 'Cerca pazienti',
    'Write the first message...': 'Scrivi il primo messaggio...',
    'Tag records': 'Tagga record',
    'Folder name': 'Nome cartella',
    Creating: 'Creazione',
    'Creating...': 'Creazione...',
    Create: 'Crea',
    'My schedule': 'La mia agenda',
    Doctors: 'Medici',
    'Telemed Visits': 'Visite telemedicina',
    'Appointment date': 'Data appuntamento',
    'Failed to load room data.': 'Impossibile caricare i dati delle stanze.',
    'Resource, title, start, and end are required.': 'Risorsa, titolo, inizio e fine sono obbligatori.',
    'End time must be after start time.': 'L orario di fine deve essere successivo all inizio.',
    'Failed to create reservation.': 'Impossibile creare la prenotazione.',
    'Reservation created.': 'Prenotazione creata.',
    'Release this reservation?': 'Rilasciare questa prenotazione?',
    'Failed to release reservation.': 'Impossibile rilasciare la prenotazione.',
    'Reservation released.': 'Prenotazione rilasciata.',
    Operations: 'Operazioni',
    'Room Management Command': 'Comando gestione stanze',
    'Live occupancy and schedulable asset command center. Rooms and equipment are fed from Settings > Schedule Assets and bookings are persisted in real time.':
      'Centro di comando per occupazione live e risorse prenotabili. Stanze e attrezzature arrivano da Impostazioni > Risorse prenotabili e le prenotazioni vengono salvate in tempo reale.',
    'Prev day': 'Giorno prec.',
    Today: 'Oggi',
    'Next day': 'Giorno succ.',
    'Manage assets': 'Gestisci risorse',
    'Active rooms': 'Stanze attive',
    'Occupied now': 'Occupate ora',
    'Available now': 'Disponibili ora',
    'Assets in use': 'Risorse in uso',
    'Loading room and resource state...': 'Caricamento stato stanze e risorse...',
    'Room occupancy': 'Occupazione stanze',
    'Rooms are blocked by appointments and manual reservations.': 'Le stanze sono bloccate da appuntamenti e prenotazioni manuali.',
    'No room-type resources found. Add resources with type "Room" in Settings > Schedule Assets.':
      'Nessuna risorsa di tipo stanza trovata. Aggiungi risorse con tipo "Room" in Impostazioni > Risorse prenotabili.',
    Room: 'Stanza',
    Current: 'Attuale',
    available: 'disponibile',
    occupied: 'occupata',
    upcoming: 'in arrivo',
    'Not occupied': 'Non occupata',
    'No upcoming booking': 'Nessuna prenotazione imminente',
    Book: 'Prenota',
    'Equipment and non-room resources available for booking.': 'Attrezzature e risorse non stanza disponibili per la prenotazione.',
    'No assets configured yet.': 'Nessuna risorsa configurata.',
    Now: 'Ora',
    Available: 'Disponibile',
    'No booking': 'Nessuna prenotazione',
    'Reservation feed': 'Flusso prenotazioni',
    'All room/asset bookings for the selected day.': 'Tutte le prenotazioni di stanze/risorse per il giorno selezionato.',
    'No reservations on this day.': 'Nessuna prenotazione in questo giorno.',
    Resource: 'Risorsa',
    'Managed by appointment': 'Gestita da appuntamento',
    Release: 'Rilascia',
    'Select resource': 'Seleziona risorsa',
    'Reason or usage': 'Motivo o utilizzo',
    Start: 'Inizio',
    End: 'Fine',
    booked: 'prenotato',
    blocked: 'bloccato',
    maintenance: 'manutenzione',
    'Save booking': 'Salva prenotazione',
    'Patient, provider, and appointment type are required': 'Paziente, medico e tipo appuntamento sono obbligatori',
    'Schedule tools': 'Strumenti agenda',
    Calendar: 'Calendario',
    Tomorrow: 'Domani',
    'This week': 'Questa settimana',
    'Clinical appointments and availability': 'Appuntamenti clinici e disponibilita',
    'Provider schedule and drag-to-reschedule': 'Agenda del medico e trascinamento per riprogrammare',
    'Month overview for scheduled appointments': 'Panoramica mensile degli appuntamenti programmati',
    'Selected day': 'Giorno selezionato',
    Visible: 'Totali',
    'Failed to load lab reports.': 'Impossibile caricare i referti di laboratorio.',
    'Failed to load report details.': 'Impossibile caricare i dettagli del referto.',
    'Failed to seed sample reports.': 'Impossibile caricare i referti di esempio.',
    'Failed to update workflow.': 'Impossibile aggiornare il flusso.',
    'Select an existing patient before creating a structured report.': 'Seleziona un paziente esistente prima di creare un referto strutturato.',
    'Add at least one lab result row with a test name.': 'Aggiungi almeno una riga risultato con un nome test.',
    'Add New Prescription': 'Aggiungi nuova prescrizione',
    'Patient Appointments': 'Appuntamenti del paziente',
    'Patient Televisits': 'Televisite del paziente',
    Document: 'Documento',
    'Patient Documents': 'Documenti del paziente',
    'Add Document': 'Aggiungi documento',
    'Upload New Document': 'Carica nuovo documento',
    'Edit Document': 'Modifica documento',
    File: 'File',
    'Document Type': 'Tipo di documento',
    Browse: 'Sfoglia',
    'Upload Document': 'Carica documento',
    'Loading document types...': 'Caricamento tipi di documento...',
    'No document types are configured yet. Create one in Settings before uploading typed documents.':
      'Nessun tipo di documento e ancora configurato. Creane uno in Impostazioni prima di caricare documenti tipizzati.',
    'Update the title, description, document type, and required metadata for this file.':
      'Aggiorna titolo, descrizione, tipo di documento e metadati obbligatori per questo file.',
    'Document uploaded successfully.': 'Documento caricato con successo.',
    'Document updated successfully.': 'Documento aggiornato con successo.',
    'A file is required.': 'E richiesto un file.',
    'Title is required.': 'Il titolo e obbligatorio.',
    'Document type is required.': 'Il tipo di documento e obbligatorio.',
    'Selected document type is invalid.': 'Il tipo di documento selezionato non e valido.',
    'Unable to load document types.': 'Impossibile caricare i tipi di documento.',
    'Lot Number': 'Numero di lotto',
    Reaction: 'Reazione',
    Description: 'Descrizione',
    Site: 'Sito',
    ADMINISTERED: 'Somministrato',
    SCHEDULED: 'Programmato',
    PARTIAL: 'Parziale',
    HISTORICAL: 'Storico',
    REFUSED: 'Rifiutato',
    CONTRAINDICATED: 'Controindicato',
    LEFT: 'Sinistro',
    RIGHT: 'Destro',
    BILATERAL: 'Bilaterale',
    LOW: 'Bassa',
    NORMAL: 'Normale',
    HIGH: 'Alta',
    URGENT: 'Urgente',
    DRAFT: 'Bozza',
    ACTIVE: 'Attivo',
    ON_HOLD: 'In pausa',
    COMPLETED: 'Completato',
    DISCONTINUED: 'Interrotto',
    SENT: 'Inviato',
    IN_PROGRESS: 'In corso',
    EXPIRED: 'Scaduto',
    low: 'bassa',
    medium: 'media',
    high: 'alta',
    'No room assigned': 'Nessuna stanza assegnata',
    'Schedulable assets': 'Risorse prenotabili',
    'No assets configured in Settings > Schedule Assets':
      'Nessuna risorsa configurata in Impostazioni > Risorse prenotabili',
    'Add rooms in Settings > Schedule Assets. Resources with type Room, Suite, Bay, or Bed appear here.':
      'Aggiungi le stanze in Impostazioni > Risorse prenotabili. Qui compaiono le risorse con tipo Room, Suite, Bay o Bed.',
    'Annual Checkup': 'Controllo annuale',
    'Follow Up': 'Controllo successivo',
    Consult: 'Consulto',
    Procedure: 'Procedura',
    'Instant Telemed': 'Telemedicina istantanea',
    Portal: 'Portale',
    Print: 'Stampa',
    Histories: 'Anamnesi',
    'No active problems': 'Nessun problema attivo',
    'No known allergies': 'Nessuna allergia nota',
    'Past medical: Hypertension (since 2016)': 'Anamnesi patologica remota: Ipertensione (dal 2016)',
    'Family: Father - HTN, Mother - T2DM': 'Anamnesi familiare: Padre - Ipertensione, Madre - Diabete tipo 2',
    'Social: Non-smoker, occasional alcohol': 'Anamnesi sociale: Non fumatore, alcol occasionale',
    'Vitals trend': 'Andamento dei parametri vitali',
    'BP 128/78 | HR 72 | SpO2 98% (stable)': 'PA 128/78 | FC 72 | SpO2 98% (stabile)',
    'No active medications.': 'Nessun farmaco attivo.',
    // Provider scheduling manager (frontend/src/features/scheduling/ProviderSchedulingManager.tsx)
    'Provider Self-Scheduling': 'Autopianificazione del fornitore',
    'Build the provider-facing schedule first, then expose only generated patient-bookable slots. The raw agenda stays hidden from the portal.':
      'Crea prima il programma visibile al fornitore, poi esponi solo gli slot generati prenotabili dai pazienti. L’agenda grezza rimane nascosta dal portale.',
    Reload: 'Ricarica',
    'Save schedule': 'Salva programma',
    'Scheduling for': 'Programmazione di',
    'Loading provider schedule...': 'Caricamento del programma del fornitore...',
    'Booking Policy': 'Politica di prenotazione',
    'These rules apply to portal slot generation and patient self-service actions.':
      'Queste regole si applicano alla generazione degli slot del portale e alle azioni di autoservizio del paziente.',
    'Minimum advance notice': 'Preavviso minimo',
    'Max days in future': 'Max giorni nel futuro',
    'Cancel notice hours': 'Ore di preavviso per cancellazione',
    'Reschedule notice hours': 'Ore di preavviso per riprogrammazione',
    'Allow same-day booking': 'Consenti prenotazione in giornata',
    'Allow portal cancellation': 'Consenti cancellazione nel portale',
    'Allow portal reschedule': 'Consenti riprogrammazione nel portale',
    'Enforce working hours for bookable windows': 'Applica l’orario di lavoro alle finestre prenotabili',
    'Recurring Availability': 'Disponibilità ricorrente',
    'Manage recurring availability in one table. Each row carries its weekday, date range, and recurrence interval, similar to Outlook-style recurrence patterns.':
      'Gestisci la disponibilità ricorrente in un’unica tabella. Ogni riga include il giorno della settimana, l’intervallo di date e l’intervallo di ricorrenza, simile ai modelli di ricorrenza di Outlook.',
    'All Recurring Availability': 'Tutta la disponibilità ricorrente',
    'Working-hours rows and portal-bookable rows are managed together here.':
      'Le righe di orario di lavoro e quelle prenotabili dal portale vengono gestite insieme qui.',
    'Recurring working hours': 'Orario di lavoro ricorrente',
    'Add new': 'Aggiungi nuovo',
    Details: 'Dettagli',
    'Staff-facing working hours': 'Orario di lavoro interno',
    Slots: 'Slot',
    'No recurring availability yet.': 'Non c’è ancora disponibilità ricorrente.',
    'Date Overrides': 'Eccezioni per data',
    'Use date-level actions to block time, add extra availability, or replace a day without exposing internal calendar detail.':
      'Usa azioni a livello di data per bloccare tempo, aggiungere disponibilità extra o sostituire una giornata senza mostrare i dettagli del calendario interno.',
    'Block day': 'Blocca giorno',
    'Block time': 'Blocca orario',
    'Add availability': 'Aggiungi disponibilità',
    'Replace day': 'Sostituisci giorno',
    'Blocked all day': 'Bloccato tutto il giorno',
    Blocked: 'Bloccato',
    'Block full day': 'Blocca giornata intera',
    'Block range': 'Blocca intervallo',
    Reason: 'Motivo',
    'Vacation, lunch, emergency block, meeting...': 'Vacanza, pranzo, blocco di emergenza, riunione...',
    'No override windows configured': 'Nessuna finestra di eccezione configurata',
    Slot: 'Slot',
    'Add override window': 'Aggiungi finestra di eccezione',
    'No date overrides yet. Use the quick actions above to block time or open extra availability.':
      'Non ci sono ancora eccezioni per data. Usa le azioni rapide sopra per bloccare tempo o aprire disponibilità extra.',
    'Add new availability': 'Aggiungi nuova disponibilità',
    'Base schedule': 'Programma base',
    'Recurring Working Hours': 'Orario di lavoro ricorrente',
    "Staff-facing availability used as the provider's weekly foundation.":
      'Disponibilità interna usata come base settimanale del fornitore.',
    'Patient booking': 'Prenotazione paziente',
    'Portal Bookable Window': 'Finestra prenotabile nel portale',
    'Recurring bookable slots with visit-type, buffer, and visibility rules.':
      'Slot prenotabili ricorrenti con regole su tipo visita, buffer e visibilità.',
    'Pick the series you want to build, then configure the weekly recurrence in the planner.':
      'Scegli la serie che vuoi creare, poi configura la ricorrenza settimanale nel pianificatore.',
    'Weekly Planner': 'Pianificatore settimanale',
    'Add working availability': 'Aggiungi disponibilità lavorativa',
    'Edit working availability': 'Modifica disponibilità lavorativa',
    "Use an Outlook-style weekly recurrence pattern for the provider's base working hours.":
      'Usa un modello di ricorrenza settimanale in stile Outlook per l’orario di lavoro base del fornitore.',
    'Series summary': 'Riepilogo serie',
    'This series creates one recurring schedule row for each checked weekday.':
      'Questa serie crea una riga di programma ricorrente per ogni giorno della settimana selezionato.',
    Pattern: 'Modello',
    Range: 'Intervallo',
    'Not set': 'Non impostato',
    'Schedule pattern': 'Modello del programma',
    'Define the daily work block and weekly recurrence in one place.':
      'Definisci il blocco di lavoro giornaliero e la ricorrenza settimanale in un unico posto.',
    'Series status': 'Stato serie',
    Recurrence: 'Ricorrenza',
    'Repeat every': 'Ripeti ogni',
    'week(s)': 'settimana/e',
    'Range of recurrence': 'Intervallo di ricorrenza',
    'Set how long this series should remain active in the provider schedule.':
      'Imposta per quanto tempo questa serie deve rimanere attiva nel programma del fornitore.',
    'Save availability': 'Salva disponibilità',
    'Add portal availability': 'Aggiungi disponibilità del portale',
    'Edit portal availability': 'Modifica disponibilità del portale',
    'Set a recurring patient-bookable series with the same weekly recurrence style used in Outlook meetings.':
      'Imposta una serie ricorrente prenotabile dai pazienti con lo stesso stile di ricorrenza settimanale usato nelle riunioni di Outlook.',
    'Portal bookable window': 'Finestra prenotabile nel portale',
    'Each checked weekday becomes its own recurring portal row, with one shared booking rule set.':
      'Ogni giorno della settimana selezionato diventa la propria riga ricorrente del portale, con un unico insieme condiviso di regole di prenotazione.',
    'Appointment time': 'Orario appuntamento',
    Max: 'Max',
    'Choose the visit setup and weekly recurrence in one combined section.':
      'Scegli la configurazione della visita e la ricorrenza settimanale in un’unica sezione combinata.',
    'Booking rules and range': 'Regole di prenotazione e intervallo',
    'Control slot behavior, visibility, and how long this recurring series stays active.':
      'Controlla il comportamento degli slot, la visibilità e per quanto tempo questa serie ricorrente rimane attiva.',
    'Slot settings': 'Impostazioni slot',
    'Slot duration': 'Durata slot',
    'Visibility and access': 'Visibilità e accesso',
    'Existing patients only': 'Solo pazienti esistenti',
    'Allow new patients': 'Consenti nuovi pazienti',
    'Allow outside working hours': 'Consenti fuori dall’orario di lavoro',
    'Select at least one weekday.': 'Seleziona almeno un giorno della settimana.',
    'Each checked day saves as its own recurring row.': 'Ogni giorno selezionato viene salvato come propria riga ricorrente.',
    'No weekdays selected': 'Nessun giorno selezionato',
    'Every day': 'Ogni giorno',
    Weekdays: 'Giorni feriali',
    'Every week': 'Ogni settimana',
    Every: 'Ogni',
    weeks: 'settimane',
    Day: 'Giorno',
    Sunday: 'Domenica',
    Monday: 'Lunedì',
    Tuesday: 'Martedì',
    Wednesday: 'Mercoledì',
    Thursday: 'Giovedì',
    Friday: 'Venerdì',
    Saturday: 'Sabato',
    Sun: 'Dom',
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mer',
    Thu: 'Gio',
    Fri: 'Ven',
    Sat: 'Sab',
    'Failed to load appointment types.': 'Impossibile caricare i tipi di appuntamento.',
    'Failed to load scheduling.': 'Impossibile caricare la programmazione.',
    'Failed to load scheduling configuration.': 'Impossibile caricare la configurazione di programmazione.',
    'Failed to load day preview.': 'Impossibile caricare l’anteprima del giorno.',
    'Failed to save scheduling.': 'Impossibile salvare la programmazione.',
    'Failed to save scheduling configuration.': 'Impossibile salvare la configurazione di programmazione.',
    'Provider scheduling saved.': 'La programmazione del fornitore è stata salvata.',
    'Email alerts': 'Avvisi email',
    'Task reminders': 'Promemoria attività',
    'Appointment alerts': 'Avvisi appuntamenti',
    'Billing alerts': 'Avvisi fatturazione',
    'Compact mode': 'Modalità compatta',
    Security: 'Sicurezza',
    'Action required': 'Azione richiesta',
    'Current Password': 'Password attuale',
    'New Password': 'Nuova password',
    'Confirm New Password': 'Conferma nuova password',
    'Password guidance: use at least 12 characters with uppercase, lowercase, a number, and a symbol.':
      'Indicazioni password: usa almeno 12 caratteri con maiuscole, minuscole, un numero e un simbolo.',
    'Do not reuse your current password.': 'Non riutilizzare la password attuale.',
    'Update Password': 'Aggiorna password',
    'Password must be at least 12 characters long.': 'La password deve contenere almeno 12 caratteri.',
    'Password must include at least one uppercase letter.': 'La password deve includere almeno una lettera maiuscola.',
    'Password must include at least one lowercase letter.': 'La password deve includere almeno una lettera minuscola.',
    'Password must include at least one number.': 'La password deve includere almeno un numero.',
    'Password must include at least one symbol.': 'La password deve includere almeno un simbolo.',
    'Enter your current password and type the new password twice.': 'Inserisci la password attuale e digita due volte la nuova password.',
    Reports: 'Report',
    Coordination: 'Coordinamento',
    'Waitlist tools': "Strumenti lista d'attesa",
    'Daily Waitlist Board': "Bacheca giornaliera lista d'attesa",
    'Manage same-day waitlists using the same day-board rhythm as the appointment calendar.':
      "Gestisci le liste d'attesa in giornata seguendo lo stesso ritmo della bacheca giornaliera del calendario appuntamenti.",
    'Board summary': 'Riepilogo bacheca',
    'providers open': 'medici aperti',
    'active patients': 'pazienti attivi',
    'Eligible Providers': 'Medici idonei',
    'Doctors with waitlist enabled in provider settings.': "Medici con lista d'attesa abilitata nelle impostazioni provider.",
    'Loading providers...': 'Caricamento medici...',
    'No providers have waitlist enabled yet in Provider Settings.':
      "Nessun medico ha ancora la lista d'attesa abilitata nelle Impostazioni provider.",
    'Not open': 'Non aperta',
    'Edit setup': 'Modifica configurazione',
    'Focus this doctor to prepare and publish the day waitlist.':
      "Seleziona questo medico per preparare e pubblicare la lista d'attesa del giorno.",
    'Calendar Waitlist': "Lista d'attesa del calendario",
    'Daily Waitlist View': "Vista giornaliera lista d'attesa",
    'Open doctors': 'Medici aperti',
    'Patients waiting': 'Pazienti in attesa',
    'Loading waitlist board...': "Caricamento bacheca lista d'attesa...",
    'No waitlists are live for this day': "Nessuna lista d'attesa è attiva per questo giorno",
    'Use the left panel to open a provider waitlist for the selected day. Once saved, the doctor will appear here as a day-view column just like the appointment calendar.':
      "Usa il pannello sinistro per aprire la lista d'attesa di un medico per il giorno selezionato. Dopo il salvataggio, il medico apparirà qui come colonna giornaliera proprio come nel calendario appuntamenti.",
    Cutoff: 'Chiusura',
    'ready soon': 'pronti a breve',
    'No patients have joined this waitlist yet.': "Nessun paziente si è ancora unito a questa lista d'attesa.",
    'Queue #': 'Coda n.',
    Rank: 'Posizione',
    'Edit Waitlist': "Modifica lista d'attesa",
    'Loading day setup...': 'Caricamento configurazione del giorno...',
    'Waitlist Details': "Dettagli lista d'attesa",
    'Date, capacity, daily opening window, and publish status':
      'Data, capacità, finestra giornaliera di apertura e stato di pubblicazione',
    'Open waitlist for this day': "Apri la lista d'attesa per questo giorno",
    'Near-term window (days)': 'Finestra a breve termine (giorni)',
    'Waitlist opens at': "La lista d'attesa apre alle",
    'Waitlist closes at': "La lista d'attesa chiude alle",
    'Cutoff time': 'Orario di chiusura',
    'Max patients': 'Pazienti massimi',
    'Team Notes': 'Note del team',
    'Internal instructions for how this same-day waitlist should be handled':
      "Istruzioni interne su come gestire questa lista d'attesa giornaliera",
    'Example: prioritize patients who can arrive immediately and keep phone lines open after lunch.':
      "Esempio: dare priorità ai pazienti che possono arrivare subito e tenere le linee telefoniche aperte dopo pranzo.",
    'Board status': 'Stato bacheca',
    'Visible on board': 'Visibile in bacheca',
    'Waiting to publish': 'In attesa di pubblicazione',
    'Patients can join this waitlist and staff can manage them from the day board.':
      "I pazienti possono unirsi a questa lista d'attesa e lo staff può gestirli dalla bacheca giornaliera.",
    'Save with the daily waitlist open to add this doctor to the board.':
      "Salva con la lista d'attesa giornaliera aperta per aggiungere questo medico alla bacheca.",
    'Queue overview': 'Panoramica coda',
    'active patients on the queue': 'pazienti attivi in coda',
    'marked as see doctor soon': 'contrassegnati come visita a breve',
    'Waitlist entry': "Voce lista d'attesa",
    'Ready by': 'Pronto entro',
    'Move up': 'Sposta su',
    'Move down': 'Sposta giù',
    'Patient moved to see doctor soon.': 'Paziente spostato in visita a breve.',
    'Mark see doctor soon': 'Segna visita a breve',
    'Entry moved back to waiting.': 'Voce riportata in attesa.',
    'Set waiting': 'Imposta in attesa',
    'Entry marked as completed.': 'Voce contrassegnata come completata.',
    'Entry cancelled.': 'Voce annullata.',
    'Internal note saved.': 'Nota interna salvata.',
    'Failed to load waitlist board.': "Impossibile caricare la bacheca lista d'attesa.",
    'Failed to load waitlist configuration.': "Impossibile caricare la configurazione della lista d'attesa.",
    'Failed to load waitlist providers.': "Impossibile caricare i medici della lista d'attesa.",
    'Waitlist settings saved and published to the daily board.':
      "Impostazioni lista d'attesa salvate e pubblicate sulla bacheca giornaliera.",
    'Waitlist settings saved and removed from the daily board.':
      "Impostazioni lista d'attesa salvate e rimosse dalla bacheca giornaliera.",
    'Unable to save waitlist.': "Impossibile salvare la lista d'attesa.",
    'Queue order updated.': 'Ordine della coda aggiornato.',
    'Unable to reorder the queue.': 'Impossibile riordinare la coda.',
    'Patient reminder email sent.': 'Email di promemoria al paziente inviata.',
    'Unable to update the waitlist entry.': "Impossibile aggiornare la voce della lista d'attesa.",
    'See doctor soon': 'Visita a breve',
    'Care Episodes': 'Episodi di cura',
    'Loading coordination workspace...': 'Caricamento workspace di coordinamento...',
    'Unable to load workspace.': 'Impossibile caricare il workspace.',
    'Failed to load coordination workspace.': 'Impossibile caricare il workspace di coordinamento.',
    'Failed to load care planning data.': 'Impossibile caricare i dati di pianificazione assistenziale.',
    'Unable to update episode.': 'Impossibile aggiornare l episodio.',
    'Unable to save care plan.': 'Impossibile salvare il piano assistenziale.',
    'Unable to update task.': 'Impossibile aggiornare l attività.',
    'Current password is invalid.': 'La password attuale non è valida.',
    'New password must be different from current password.': 'La nuova password deve essere diversa da quella attuale.',
    'Unable to load assignees.': 'Impossibile caricare gli assegnatari.',
    'Task title is required.': 'Il titolo dell’attività è obbligatorio.',
    'Unable to create task.': 'Impossibile creare l’attività.',
    '{count} points': '{count} punti',
    'Reason for visit or notes': 'Motivo della visita o note',
    'Upload photo': 'Carica foto',
    'Action failed': 'Azione non riuscita',
    'The requested action could not be completed.': 'Non è stato possibile completare l’azione richiesta.',
    'Patient note created': 'Nota paziente creata',
    'Patient note updated': 'Nota paziente aggiornata',
    'Patient note changes were saved.': 'Le modifiche alla nota del paziente sono state salvate.',
    'Patient document removed': 'Documento paziente rimosso',
    'Patient document uploaded': 'Documento paziente caricato',
    'Patient document changes were saved.': 'Le modifiche al documento del paziente sono state salvate.',
    'Appointment updated': 'Appuntamento aggiornato',
    'Appointment changes were saved.': 'Le modifiche all’appuntamento sono state salvate.',
    'Prescription updated': 'Prescrizione aggiornata',
    'Prescription changes were saved.': 'Le modifiche alla prescrizione sono state salvate.',
    'Billing updated': 'Fatturazione aggiornata',
    'Billing changes were saved.': 'Le modifiche alla fatturazione sono state salvate.',
    'Telemedicine updated': 'Telemedicina aggiornata',
    'Telemedicine changes were saved.': 'Le modifiche alla telemedicina sono state salvate.',
    'Patient record updated': 'Cartella paziente aggiornata',
    'Patient record changes were saved.': 'Le modifiche alla cartella del paziente sono state salvate.',
    'System activity captured': 'Attività di sistema registrata',
    'Changes were saved successfully.': 'Le modifiche sono state salvate correttamente.',
    on: 'il',
  },
};

type PhrasePattern = {
  regex: RegExp;
  replacement: string;
};

const phrasePatternTranslations: Record<SupportedLanguage, PhrasePattern[]> = {
  en: [],
  es: [
    { regex: /^Last visit (.+)$/i, replacement: 'Última visita $1' },
    { regex: /^Next: (.+)$/i, replacement: 'Próxima: $1' },
    { regex: /^Generated (.+) • cached$/i, replacement: 'Generado $1 • en caché' },
    { regex: /^Generated (.+)$/i, replacement: 'Generado $1' },
    { regex: /^MRN (.+)$/i, replacement: 'MRN $1' },
  ],
  it: [
    { regex: /^Last visit (.+)$/i, replacement: 'Ultima visita $1' },
    { regex: /^Next: (.+)$/i, replacement: 'Prossima: $1' },
    { regex: /^Generated (.+) • cached$/i, replacement: 'Generato $1 • in cache' },
    { regex: /^Generated (.+)$/i, replacement: 'Generato $1' },
    { regex: /^MRN (.+)$/i, replacement: 'MRN $1' },
  ],
};

export function translateUiPhrase(language: SupportedLanguage, phrase: string): string {
  const normalized = phrase.trim();
  if (!normalized || language === 'en') return phrase;

  const table = phraseTranslations[language] ?? {};
  if (table[normalized]) {
    return phrase.replace(normalized, table[normalized]);
  }

  const patterns = phrasePatternTranslations[language] ?? [];
  for (const pattern of patterns) {
    if (pattern.regex.test(normalized)) {
      return phrase.replace(normalized, normalized.replace(pattern.regex, pattern.replacement));
    }
  }

  return phrase;
}
